// Magyar szövegek az Outfino Partner Portálhoz.
const hu = {
  // ---- Signed-out landing (pages/Login.js) ----
  'landing.partners': 'Partners',
  'landing.kicker': 'KYC a divatnak',
  'landing.title': 'Ismerd meg a vásárlóidat.',
  'landing.shopUrl': 'webshop.hu/termek/merino-pulover',
  'landing.productCrumb': 'Pulóverek',
  'landing.productPrice': '24\u00a0990\u00a0Ft',
  'landing.addToCart': 'Kosárba',
  'landing.demoLabel': 'Egy webshop termékoldala az Outfino gombbal',
  'landing.productName': 'Merinó pulóver',
  'landing.visitor.title': 'Mit kap a látogatód?',
  'landing.visitor.match.title': 'Százalékos illeszkedés',
  'landing.visitor.match.body': 'Látja, mennyire illik hozzá a termék.',
  'landing.visitor.why.title': 'Rövid indoklás',
  'landing.visitor.why.body': 'Megtudja, miért illik hozzá – vagy miért nem.',
  'landing.visitor.wardrobe.title': 'Gardrób a fotóiból',
  'landing.visitor.wardrobe.body': 'A feltöltött fotóiból összeáll a saját gardróbja.',
  'landing.visitor.follow.title': 'Követés és drop-értesítő',
  'landing.visitor.follow.body': 'Követheti a márkádat, és szólunk neki az új dropokról.',
  'landing.brand.title': 'Mit kapsz te?',
  'landing.brand.returns.title': 'Kevesebb visszaküldés',
  'landing.brand.returns.body': 'Azt rendelik meg, ami tényleg illik hozzájuk.',
  'landing.brand.quality.title': 'Jobb minőségű vásárlók',
  'landing.brand.quality.body': 'Olyanok vásárolnak, akikhez illik a márkád.',
  'landing.brand.conversion.title': 'Több konverzió',
  'landing.brand.conversion.body': 'A „jól áll-e?” kérdésre ott kapnak választ.',
  'landing.brand.reach.title': 'Követők és elérés',
  'landing.brand.reach.body': 'Promóciók és új termékek egyenesen a követőidnek.',
  'landing.brand.insights.title': 'Látogatók a portálon',
  'landing.brand.insights.body': 'Termékenként látod a látogatókat és a konverziókat.',
  'landing.mobileLead': 'Egy gomb a termékoldaladon, ami megmutatja, mennyire illik a termék a vásárlóhoz.',
  'landing.stickyNote': 'Új márka? 1 hónap ingyen',
  'landing.stickyCta': 'Belépés',
  'landing.newBrand': 'Új márka? Lépj be, és pár perc alatt beállítod –\u00a01\u00a0hónap ingyenes próbaidővel.',
  'landing.themeDark': 'Sötét mód',
  'landing.themeLight': 'Világos mód',
  'landing.terms': 'ÁSZF',
  'landing.privacy': 'Adatvédelem',
  'landing.contact': 'Kapcsolat',

  // ---- Login ----
  'login.title': 'Partner Portál',
  'seo.home.title': 'Outfino márkáknak',
  'seo.home.description': 'Outfino márkáknak: tedd a márkádat személyre szabott vásárlási élménnyé. Érd el azokat a vásárlókat, akiknek a stílusa illik a márkádhoz, kösd be a Shopify-t, és kezelj mindent egy felületen.',
  'login.subtitle': 'Jelentkezz be a márkád kezeléséhez.',
  'login.email': 'E-mail cím',
  'login.password': 'Jelszó',
  'login.submit': 'Bejelentkezés',
  'login.loading': 'Bejelentkezés…',
  'login.wrongCredentials': 'Hibás e-mail vagy jelszó.',
  'login.networkError': 'Hálózati hiba. Próbáld újra.',
  'login.googleShort': 'Google',
  'login.appleShort': 'Apple',
  'login.google': 'Bejelentkezés Google-lel',
  'login.apple': 'Bejelentkezés Apple-lel',
  'login.or': 'vagy',
  'login.googleFailed': 'Google bejelentkezés sikertelen.',
  'login.googleCloseWindow': 'Bejelentkezve. Ezt az ablakot bezárhatod.',
  'login.appleUnavailable': 'Apple bejelentkezés nem elérhető.',
  'login.appleFailed': 'Apple bejelentkezés sikertelen.',

  // ---- Dashboard shell ----
  'shell.brand': 'Márka',
  'shell.envDev': 'DEV',
  'shell.logout': 'Kijelentkezés',
  'shell.loading': 'Betöltés…',
  'shell.refresh': 'Frissítés',
  'group.mobile': 'Outfino Mobile App',
  'tab.events': 'Eseménynaptár',
  'tab.prize-pool': 'Prize Pool',
  'tab.embedded-stats': 'Statisztikák',
  'tab.embedded-visitors': 'Látogatók',
  'shell.comingSoon': 'Hamarosan elérhető.',
  'sidebar.expand': 'Kinyitás',
  'sidebar.collapse': 'Összecsukás',
  'sidebar.menu': 'Menü',
  'sidebar.menuClose': 'Menü bezárása',
  'theme.light': 'Világos',
  'theme.dark': 'Sötét',
  'theme.lightTitle': 'Világos téma',
  'theme.darkTitle': 'Sötét téma',
  'lang.name': 'Magyar',
  'lang.switchTitle': 'Angolra váltás',
  'shell.connectedReturn': 'A boltod csatlakoztatva van az Outfinóhoz.',
  'shell.openPortal': 'Átlépés az Outfino Partnersbe',
  'shell.notLinked': 'Ez a bolt még nincs Outfino fiókhoz kapcsolva.',
  'shell.linkAccount': 'Összekapcsolás az Outfino Partnersben',
  'shell.openInShopifyAdmin': 'Shopify admin',
  'return.title': 'A boltod csatlakoztatva van',
  'return.body':
    'Folytasd az Outfino partner portálon — ott kezelheted a márkádat, a termékeidet és a kifizetéseidet.',
  'shell.embeddedNoSession':
    'Nyisd meg ezt az oldalt a Shopify adminban, az Alkalmazások › Outfino alatt.',

  // ---- No brand yet ----
  'empty.title': 'Még nincs márkád',
  'empty.body': 'Hozd létre a márkádat pár perc alatt: név, logó, borítókép és a webshopod címe. Utána megadod a kártyát, és indul az 1 hónapos ingyenes próbaidő.',
  'empty.create': 'Új márka létrehozása',

  // ---- Connect Shopify modal ----
  'shopify.title': 'Shopify csatlakoztatása',
  'shopify.body':
    'Add meg a Shopify áruházad domainjét a csatlakoztatáshoz. Átirányítunk a Shopify-ra a hozzáférés jóváhagyásához, majd visszahozunk ide.',
  'shopify.shopLabel': 'Shopify áruház domain',
  'shopify.shopPlaceholder': 'a-boltod.myshopify.com',
  'shopify.connect': 'Csatlakoztatás',
  'shopify.cancel': 'Mégse',
  'shopify.invalid': 'Adj meg egy érvényes .myshopify.com domaint.',

  // ---- Linking a store back from Shopify ----
  'connect.linking': 'Bolt csatolása a fiókodhoz…',
  'connect.syncing': 'Szinkronizálás…',
  'connect.syncingHint': 'A bolt összekapcsolása az Outfino fiókoddal. Ez csak néhány másodperc.',
  'connect.returning': 'Átirányítás az Outfino Partnersbe…',
  'connect.returningHint': 'Ez a bolt még nincs Outfino fiókhoz kapcsolva. Jelentkezz be az Outfino Partnersbe az összekapcsoláshoz.',
  'connect.returningLink': 'Tovább az Outfino Partnersbe',
  'connect.failed':
    'Nem sikerült csatolni a boltot. Próbáld újra a „Brand hozzáadása” gombbal.',
  'connect.alreadyLinked': 'Ez a bolt már egy másik Outfino fiókhoz tartozik.',

  // ---- Shopify-kapcsolat sáv (documents#637) ----
  'connection.reauthTitle':
    'A Shopify-kapcsolat megszakadt — nyisd meg az Outfino appot a Shopify Adminban az újracsatlakozáshoz.',
  'connection.reauthCta': 'Outfino app megnyitása a Shopifyban',
  'products.inactive': 'Inaktív',
  'brandInactive.title': 'A márka jelenleg inaktív.',
  'brandInactive.body': 'A termékei nem jelennek meg az Outfino appban, és nem vásárolhatók meg.',
  'brandInactive.contact': 'Az újraaktiváláshoz vedd fel a kapcsolatot az Outfino adminisztrátoraival.',
  'brandInactive.cta': 'Kapcsolatfelvétel',
  'brandInactive.mailSubject': 'Inaktív márka',
  'brandSuspended.title': 'A márkádat az Outfino felfüggesztette.',
  'brandSuspended.body': 'Kérdés esetén írj nekünk.',
  'brandSuspended.cta': 'Írj nekünk',
  'brandSuspended.mailSubject': 'Felfüggesztett márka',
  'connection.disconnectedTitle': 'Az Outfino app nincs telepítve ebben a boltban.',
  'connection.disconnectedCta': 'Telepítés / újracsatlakozás',
  'connection.lastOk': 'Utoljára sikeres: {time}',
  'connection.lastOkNever': 'Még nem volt sikeres kapcsolat',
  'connection.err.tokenExpired': 'A Shopify hozzáférési token lejárt.',
  'connection.err.tokenRejected': 'A Shopify visszautasította vagy visszavonta a hozzáférési tokent.',
  'connection.err.scopeMissing':
    'Hiányzik egy jogosultság ({scope}) — engedélyezd a hiányzó jogosultságot az app megnyitásával.',
  'connection.err.uninstalled': 'Az app el lett távolítva a boltból.',
  'connection.err.generic': 'Ok: {code}',

  // ---- Brand dashboard tabs ----
  'tab.profile': 'Profil',
  'tab.products': 'Termékek',
  'tab.stats': 'Statisztikák',
  'tab.orders': 'Rendelések',
  'orders.title': 'Rendelések',
  'orders.hint': 'Minden, ami az Outfinón keresztül kelt el és neked kell teljesítened. Az összegek a jutalék utáni részed.',
  'orders.loading': 'Rendelések betöltése…',
  'orders.loadError': 'A rendeléseket nem sikerült betölteni.',
  'orders.empty': 'Még nincs rendelés.',
  'orders.units': '{n} tétel',
  'orders.subtotal': 'Termékek',
  'orders.shipping': 'Szállítás',
  'orders.yourShare': 'A te részed ({n}% jutalék után)',
  'orders.method': 'Szállítási mód',
  'orders.deliverTo': 'Kiszállítás ide',
  'orders.shopifyOrder': 'Shopify rendelés',
  'orders.noShopifyOrder': 'Nem jött létre a Shopifyban',

  // ---- Szállítás (#623 B4 — csak olvasás; a Shopify az egyetlen forrás) ----
  'tab.shipping': 'Szállítás',
  'shipping.title': 'Szállítási lefedettség',
  'shipping.source': 'A szállítási országokat és módokat a Shopify beállításaidból olvassuk.',
  'shipping.sourceHowTo': 'A lefedettséget és a díjakat a Shopify Adminban módosíthatod (Settings → Shipping and delivery). A változás automatikusan átjön az Outfinóba, vagy használd a Frissítés gombot.',
  'shipping.refresh': 'Frissítés',
  'shipping.refreshing': 'Frissítés…',
  'shipping.loading': 'Szállítási lefedettség betöltése…',
  'shipping.loadError': 'A szállítási lefedettséget nem sikerült betölteni.',
  'shipping.noCoverage': 'A Shopify beállításaidban még nincs szállítási zóna.',
  'shipping.countryCount': '{n} ország',
  'shipping.restOfWorldChip': 'A világ többi része',
  'shipping.zoomIn': 'Nagyítás',
  'shipping.zoomOut': 'Kicsinyítés',
  'shipping.legendCovered': 'Shopify-lefedett ország',
  'shipping.legendRestOfWorld': 'A világ többi része — minden más ország',
  'shipping.legendNone': 'Nincs szállítás',
  'shipping.pickCountry': 'Válassz egy kiemelt országot, hogy lásd az ott elérhető szállítási módokat.',
  'shipping.shopifyMethodsHead': 'Shopify módok',
  'shipping.methodsLoading': 'Módok betöltése…',
  'shipping.methodsError': 'Az ország szállítási módjait nem sikerült betölteni.',
  'shipping.methodsEmpty': 'Ehhez az országhoz nincs elérhető szállítási mód.',
  'shipping.methodsEmptyButCovered': 'A Shopify beállításaid szerint ide elvileg szállítasz, de a Shopify most nem adott konkrét módot ehhez az országhoz.',
  'shipping.methodsEmptyCheckoutHint': 'A konkrét díjat a vevő címére a Shopify számolja ki a pénztárnál.',
  'shipping.priceAtCheckout': 'Ár a fizetésnél',
  'shipping.notConnectedTitle': 'Kösd össze a Shopify boltod',
  'shipping.notConnectedBody': 'Kösd össze a Shopify boltod, hogy lásd, mely országokba és milyen módokkal szállítasz.',
  'shipping.accessDeniedTitle': 'Frissítsd a Shopify kapcsolatot',
  'shipping.accessDeniedBody': 'Nem tudjuk kiolvasni a szállítási beállításaidat — a Shopify kapcsolatból hiányzik a szállítási jogosultság. Kérjük, kösd össze újra a boltot, hogy megadd.',
  'shipping.genericErrorTitle': 'A szállítás nem elérhető',
  'shipping.genericErrorBody': 'A szállítási beállításaidat most nem sikerült kiolvasni a Shopifyból. Kérjük, próbáld újra később.',
  // documents#637 — visszautasított token (shopify_reauth_required), ill. a
  // hiányzó read_shipping jogosultság (shipping_access_denied + scope_missing).
  'shipping.reauthTitle': 'Csatlakoztasd újra a Shopify boltod',
  'shipping.reauthBody':
    'A Shopify-kapcsolat megszakadt — nyisd meg az Outfino appot a Shopify Adminban az újracsatlakozáshoz.',
  'shipping.scopeMissingTitle': 'Jogosultság kell a szállítási beállításokhoz',
  'shipping.scopeMissingBody':
    'A szállítási beállítások olvasásához jogosultság kell — nyisd meg az Outfino appot a Shopify Adminban, és fogadd el a kért jogosultságot.',
  'shipping.openShopifyApp': 'Outfino app megnyitása a Shopifyban',
  // #623 — a cache-elt lefedettség állapota, amire a vásárlói szűrés épül.
  'shipping.statusValid': 'Szinkronban a Shopify-jal, frissítve: {time}',
  'shipping.statusStale': 'Az adat {days} napja nem frissült — ellenőrizd a Shopify-kapcsolatot',
  'shipping.statusStaleNoDate': 'A lefedettségi adat elavult lehet — ellenőrizd a Shopify-kapcsolatot',
  'shipping.statusUnknown': 'Nem sikerült beolvasni a Shopify szállítási beállításait — nyisd meg az Outfino appot a Shopify Adminban, vagy ellenőrizd a jogosultságokat',

  'tab.payouts': 'Kifizetések',
  'tab.members': 'Tagok',
  'tab.drops': 'Dropok',
  'tab.campaigns': 'Creator kampányok',
  'tab.challenges': 'Játékok',
  'tab.special': 'Speciális',

  // ---- Creator campaigns ----
  'campaigns.title': 'Creator kampányok',
  'campaigns.new': 'Új brief',
  'campaigns.empty': 'Még nem hoztál létre briefet. Kezdd az elsővel!',
  'campaigns.back': 'Vissza',
  'campaigns.applicantsCount': '{count} jelentkező',
  'campaigns.selectedCount': '{done}/{total} kiválasztva',
  'campaigns.applicants': 'Jelentkezők',
  'campaigns.noApplicants': 'Erre a briefre még nem jelentkezett senki.',
  'campaigns.selected': 'Kiválasztva',
  'campaigns.select': 'Kiválasztás',
  'campaigns.deselect': 'Elvetés',
  'campaigns.slots': '{count} creator kell',
  'campaigns.videos': '{count} videó / creator',
  'campaigns.applyDeadline': 'Jelentkezési határidő',
  'campaigns.deliveryDeadline': 'Leadási határidő',
  'campaigns.status.open': 'Nyitott',
  'campaigns.status.selecting': 'Kiválasztás alatt',
  'campaigns.status.in_progress': 'Folyamatban',
  'campaigns.status.completed': 'Lezárult',
  // New brief form
  'campaigns.newTitle': 'Új brief létrehozása',
  'campaigns.fTitle': 'Cím',
  'campaigns.fDescription': 'Leírás',
  'campaigns.fSlots': 'Hány creator kell?',
  'campaigns.fVideos': 'Videó / creator',
  'campaigns.fPayment': 'Díjazás',
  'campaigns.fPaymentPh': 'pl. Jóváhagyott videónként díjazás + bónusz',
  'campaigns.create': 'Brief létrehozása',
  'campaigns.creating': 'Létrehozás...',
  'campaigns.cancel': 'Mégse',
  'campaigns.fAmount': 'Összeg',
  'campaigns.fAmountPh': 'pl. 150',
  'campaigns.fCurrency': 'Pénznem',
  'campaigns.loading': 'Kampányok betöltése...',
  'campaigns.error': 'Nem sikerült betölteni a kampányokat. Próbáld újra.',

  // ---- Brand profile ----
  'profile.title': 'Márkaprofil',
  'profile.logo': 'Logó módosítása',
  'profile.cover': 'Borítókép módosítása',
  'profile.coverHint': 'Adj hozzá borítóképet',
  'profile.name': 'Márkanév',
  'profile.company': 'Cégnév',
  'profile.tagline': 'Szlogen',
  'profile.taglineHint': 'Egy sor a márkanév alatt az appban (max. 140 karakter)',
  'profile.description': 'Leírás',
  'profile.phone': 'Telefonszám',
  'profile.website': 'Weboldal',
  'profile.address': 'Cím',
  'profile.iban': 'IBAN (kifizetésekhez)',
  'profile.visibility': 'A márka látható az Outfinóban',
  'profile.save': 'Mentés',
  'profile.saving': 'Mentés…',
  'profile.saved': 'Mentve.',
  'profile.saveError': 'Nem sikerült menteni. Próbáld újra.',
  'profile.readOnly': 'Nincs jogosultságod a márka szerkesztéséhez.',
  'profile.websiteMoved': 'A webshop címét a Beállítások oldalon, a Márkaprofil „A webshop címe” mezőjében adhatod meg.',
  'profile.websiteLink': 'Ugrás oda',
  'profile.ibanNeedsBilling': 'Az IBAN-t a márka tulajdonosa vagy számlázási jogosultságú tag módosíthatja.',
  'profile.notStoredYet': 'Ezt a mezőt a szerver még nem tudja menteni.',
  'profile.visibilitySuspended': 'Az Outfino felfüggesztette a márkádat, ezért ez a kapcsoló most nem teszi láthatóvá. Kérdés esetén írj nekünk.',
  'profile.err.iban': 'Érvénytelen IBAN. Ellenőrizd a számot (pl. HU42 1177 3016 1111 1018 0000 0000).',
  'profile.err.ibanPermission': 'Az IBAN módosításához számlázási jogosultság kell.',
  'profile.err.companyName': 'A cégnév túl hosszú (legfeljebb 255 karakter).',
  'profile.err.address': 'A cím túl hosszú (legfeljebb 500 karakter).',
  'profile.err.adminOnly': 'Ezt a mezőt csak az Outfino módosíthatja.',

  // ---- Products ----
  'products.title': 'Termékek',
  'products.empty':
    'Még nincsenek termékek. Szinkronizáld a Shopify katalógust az importáláshoz.',
  'products.sync': 'Termékek szinkronizálása',
  'products.syncing': 'Szinkronizálás…',
  'products.syncStarted': 'A szinkronizálás elindult — ez eltarthat egy ideig.',
  'products.openInShopify': 'Megnyitás a Shopifyban',
  'products.search': 'Termékek keresése',
  'products.noMatch': 'Nincs a keresésnek megfelelő termék.',
  'products.loadError': 'Nem sikerült betölteni a termékeket.',
  'products.retry': 'Újra',
  'products.soldOut': 'Elfogyott',
  'products.stockCount': '{n} db készleten',
  'products.stockUntracked': 'Nincs készletkövetés',
  'products.stockVariantsOut': '{total} változatból {out} elfogyott',
  // #615 — szinkron folyamatjelző + a besorolásból kimaradt termékek.
  'products.syncProgress': 'Termékek szinkronizálása',
  'products.syncCount': '{done} / {total}',
  'products.syncPreparing': 'Katalógus beolvasása…',
  // Weboldal-crawl ("Termékek fetchelése") — a nem Shopify-s márkáknak.
  'products.crawl': 'Termékek fetchelése',
  'products.crawling': 'Fetchelés…',
  'products.crawlSoon': 'Hamarosan',
  'products.lastCrawl': 'Utoljára fetchelve: {ago}',
  'products.lastCrawlCount': '· {n} termék',
  'products.lastCrawlNever': 'Még nem futtattál termék-lekérést',
  'products.crawlPhase.queued': 'Előkészítés…',
  'products.crawlPhase.discovering': 'Termékek felderítése…',
  'products.crawlPhase.ingesting': 'Termékek beolvasása…',
  'products.crawlPhase.done': 'Kész',
  'products.crawlProgress': 'Találat: {found} · beolvasva: {ingested}',
  'products.crawlDone': 'Kész — {n} termék beolvasva.',
  'products.crawlError.NO_PRODUCTS': 'Nem találtunk termékeket ezen a címen.',
  'products.crawlError.DOMAIN_NOT_SET': 'Előbb állítsd be a webshop címét.',
  'products.crawlError.CRAWL_FAILED': 'A lekérés nem sikerült. Próbáld újra később.',
  'products.crawlSetDomain': 'Beüzemelés',
  'products.emptyCrawl':
    'Még nincs terméked. Kattints a „Termékek fetchelése” gombra a webshopod termékeinek beolvasásához.',
  'products.excludedTitle': 'Nem ruházatként felismert termékek',
  'products.excludedHint':
    'Ezek a termékek szinkronizálódtak, de a besoroló nem ruházatként ismerte fel őket, ezért a vásárlók nem látják őket az Outfinón.',
  // documents#188 — termékenkénti AI-címkézés státusz (ai_labeling a listán).
  'products.labelPending': 'Címkézés folyamatban…',
  'products.labelDone': 'Címkézve',
  'products.labelDoneCategory': 'Címkézve: {category}',
  'products.labelFailed': 'Címkézés sikertelen',
  'products.labelSkipped': 'Nem címkézhető',
  'products.labelRetry': 'Újra',
  'products.labelRetrying': 'Sorba állítás…',
  'products.labelNotLabelable': 'Ez a termék nem címkézhető (törölt, vagy nincs Shopify-adata).',
  'products.labelRetryFailed': 'Nem sikerült elindítani a címkézést. Próbáld újra.',
  'products.disputeAction': 'Hibás besorolás?',
  'products.disputeTitle': 'Hibás besorolás jelzése',
  'products.disputeVerdictNotClothing': 'Az AI szerint: nem ruha',
  'products.disputeAskClothing': 'Felülvizsgálatot kérsz, hogy a termék „ruha” besorolást kapjon.',
  'products.disputeMessage': 'Üzenet (nem kötelező)',
  'products.disputeMessageHint': 'Miért gondolod, hogy hibás a besorolás?',
  'products.disputeSubmit': 'Felülvizsgálat kérése',
  'products.disputeSending': 'Küldés…',
  'products.disputeCancel': 'Mégse',
  'products.disputePending': 'Felülvizsgálat folyamatban',
  'products.disputeRejected': 'Kérelem elutasítva',
  'products.disputeSentOn': 'Beküldve: {date}',
  'products.disputeApprovedAs': 'Ruhaként szerepel',
  'products.disputeApprovedAsCategory': 'Ruhaként szerepel · {category}',
  'products.disputeNoReason': 'Az admin nem írt indoklást.',
  'products.disputeAgain': 'Új kérés',
  'products.disputeApproved': 'Kérelem elfogadva',
  'products.disputeNotDisputable': 'Ez a termék most nem kifogásolható (törölt, vagy még címkézés alatt áll).',
  'products.disputeFailed': 'Nem sikerült elküldeni a kérést. Próbáld újra.',

  // ---- Drops ----
  'drops.title': 'Dropok',
  'drops.empty': 'Még nincs drop',
  'drops.status.scheduled': 'Ütemezett',
  'drops.status.active': 'Aktív',
  'drops.status.completed': 'Lezárult',
  'drops.status.cancelled': 'Törölve',
  'drops.new': 'Új drop',
  'drops.cancelFailed': 'Nem sikerült törölni a dropot. Próbáld újra.',
  'drops.form.title': 'Új drop',
  'drops.form.date': 'Időpont',
  'drops.form.create': 'Drop ütemezése',
  'drops.form.noDate': 'Még nincs időpont',
  'drops.form.close': 'Bezárás',
  'drops.form.creating': 'Ütemezés…',
  'drops.form.failed': 'Nem sikerült ütemezni a dropot. Próbáld újra.',

  // ---- Stats ----
  'stats.title': 'Statisztikák',
  'stats.available': 'Elérhető egyenleg',
  'stats.totalEarned': 'Összes bevétel',
  'stats.thisMonth': 'Ebben a hónapban',
  'stats.orders': 'Rendelések',
  'stats.revenue': 'Bevétel',
  'stats.payouts': 'Kifizetések',
  'stats.noPayouts': 'Még nincs kifizetés.',
  'stats.period.day': 'Nap',
  'stats.period.week': 'Hét',
  'stats.period.month': 'Hónap',
  'stats.period.year': 'Év',
  'stats.period.all': 'Összes',

  // ---- Payouts ----
  'payouts.title': 'Kifizetések',
  'payouts.request': 'Kifizetés igénylése',
  'payouts.requesting': 'Igénylés…',
  'payouts.requested': 'Kifizetési igény elküldve.',
  'payouts.requestError': 'Nem sikerült elküldeni az igényt. Próbáld újra.',
  'payouts.pending': 'Függőben',
  'payouts.history': 'Kifizetési előzmények',
  'payouts.commissionNote': '{pct}% Outfino-jutalék levonása után',
  'payouts.breakdownTitle': 'Bevétel bontása',
  'payouts.gross': 'Bruttó bevétel',
  'payouts.commissionLine': 'Outfino-jutalék ({pct}%)',
  'payouts.net': 'Nettó – a tiéd',

  // ---- Members ----
  'members.title': 'Tagok',
  'members.empty': 'Még nincsenek tagok.',
  'members.anonymous': 'Névtelen',
  'members.role.owner': 'Tulajdonos',
  'members.role.member': 'Tag',
  'members.devLocked': 'Fejlesztői brandhez nem adhatsz hozzá új tagot.',
  'members.add': 'Új tag',
  'members.searchPlaceholder': 'Keresés felhasználónévre…',
  'members.searchEmpty': 'Nincs találat.',
  'members.remove': 'Eltávolítás',

  // ---- Permissions ----
  'perm.viewProducts': 'Termékek megtekintése',
  'perm.editProducts': 'Termékek szerkesztése',
  'perm.viewOrders': 'Rendelések megtekintése',
  'perm.viewAnalytics': 'Statisztikák megtekintése',
  'perm.manageMembers': 'Tagok kezelése',
  'perm.manageCampaigns': 'Kampányok kezelése',
  'perm.editBrand': 'Márka szerkesztése',
  'perm.manageBilling': 'Számlázás kezelése',

  // ---- Danger zone (delete brand) ----
  'danger.title': 'Veszélyzóna',
  'danger.deleteBrand': 'Márka eltávolítása',
  'danger.deleteBody': 'Az Outfino lekerül a Shopify boltodról, a termékeid eltűnnek az Outfinóról, a márkából pedig minden tag kikerül, téged is beleértve. Aki legközelebb csatlakoztatja a boltot, az lesz az új tulajdonos. Ez nem vonható vissza.',
  'danger.confirm': 'Biztosan eltávolítod a(z) {name} márkát? Ez nem vonható vissza.',
  'danger.error': 'Nem sikerült eltávolítani a márkát. Próbáld újra.',
  'danger.deleting': 'Eltávolítás…',
  // ---- Challenges / galaxy gift drops (GiftDropsTab) ----
  'gifts.title': 'Ajándékláda a galaxisban',
  'gifts.lead': 'Dobj be egy ládát az Outfino app Style Universe galaxisába. Kívülről úszik be, kb. 100 másodperc alatt átúszik a galaxison, és aki elsőként megérinti, elviszi. Ha senki nem kapja el, kiúszik.',
  'gifts.dropButton': 'Ajándék bedobása a galaxisba',
  'gifts.dropped': 'A láda úton van a galaxisba.',
  'gifts.cancelled': 'A ládát visszavontad.',
  'gifts.activeTitle': 'Aktív ládák',
  'gifts.polling': 'Frissítés {s} mp-enként',
  'gifts.pollingTitle': 'Az oldal magától frissül: gyakrabban, amíg láda úszik a galaxisban.',
  'gifts.live': 'Élő',
  'gifts.liveTitle': 'Élő kapcsolat: a változások azonnal megjelennek.',
  'gifts.err.brandInactive': 'A márkád most nem látható az Outfinón, ezért nem dobhatsz be ládát.',
  'gifts.err.notEligible': 'Ez a márka most nem dobhat be ládát a galaxisba.',
  'gifts.err.followersOnly': 'Ezt a ládát csak a márka követői kaphatják el.',
  'gifts.err.brandNotFound': 'Ez a márka nem található.',
  'gifts.followersOnly': 'Csak követőknek',
  'gifts.followersOnlyTitle': 'Csak a márkád követői kaphatják el; a többiek láncokkal lezárva látják.',
  'gifts.modal.followersOnly': 'Csak követőknek',
  'gifts.modal.followersOnlyHint': 'Akik nem követik a brandet, a ládát láncokkal lezárva látják, és nem kaphatják el.',
  'gifts.retry': 'Újra',
  'gifts.noActive': 'Most nincs ládád a galaxisban.',
  'gifts.historyTitle': 'Előzmények',
  'gifts.noHistory': 'Még nem dobtál be ládát.',
  'gifts.loadMore': 'Továbbiak betöltése',
  'gifts.someone': 'Valaki',
  'gifts.seconds': '{n} mp',
  'gifts.cancel': 'Visszavonás',
  'gifts.cancelTitle': 'Visszavonod a ládát?',
  'gifts.cancelText': 'A láda (bedobva: {at}) azonnal eltűnik a galaxisból, és senki sem kaphatja el. Ez nem vonható vissza.',
  'gifts.cancelling': 'Visszavonás…',
  'gifts.cancelConfirm': 'Igen, visszavonom',
  'gifts.phase.incoming': 'beúszik a galaxisba',
  'gifts.phase.inside': 'a peremig',
  'gifts.phase.leaving': 'kiúszik a galaxisból',
  'gifts.status.active': 'Aktív',
  'gifts.status.collected': 'Elkapták',
  'gifts.status.expired': 'Kiúszott',
  'gifts.status.cancelled': 'Visszavonva',
  'gifts.col.createdAt': 'Létrehozva',
  'gifts.col.status': 'Státusz',
  'gifts.col.winner': 'Nyertes',
  'gifts.col.reaction': 'Reakcióidő',
  'gifts.col.crossing': 'Átkelés',
  'gifts.modal.title': 'Ajándék bedobása a galaxisba',
  'gifts.modal.logoTitle': 'A ládán a te logód látszik',
  'gifts.modal.logoText': 'Mindenki látja, aki éppen a galaxist nézi az appban.',
  'gifts.modal.text': 'A láda a galaxis peremén kívülről úszik be, kb. 100 másodperc alatt széltől szélig átúszik, és aki az Outfino appban elsőként megérinti, elviszi. Ha senki nem kapja el, kiúszik.',
  'gifts.modal.reward': 'Ajándék',
  'gifts.modal.rewardSoon': 'Ajándék (kupon) — hamarosan',
  'gifts.modal.rewardHint': 'Hamarosan kupont is tehetsz a ládába. Addig a láda ajándék nélkül úszik.',
  'gifts.modal.note': 'Megjegyzés (nem kötelező)',
  'gifts.modal.notePlaceholder': 'Pl. őszi kampány — csak nektek látszik',
  'gifts.modal.back': 'Mégse',
  'gifts.modal.dropping': 'Bedobás…',
  'gifts.modal.confirm': 'Bedobom',
  'gifts.err.galaxyFull': 'Most túl sok láda úszik a galaxisban, próbáld újra pár perc múlva.',
  'gifts.err.notActive': 'Ez a láda már nincs a galaxisban.',
  'gifts.err.notActiveStatus': 'Ez a láda már nincs a galaxisban ({status}).',
  'gifts.err.notFound': 'Ez a láda nem található.',
  'gifts.err.invalid': 'Valamelyik mező hibás. Ellenőrizd a megjegyzést, és próbáld újra.',
  'gifts.err.disabled': 'A ládák bedobása most nem elérhető.',
  'gifts.err.forbidden': 'Ehhez a márkához nincs jogosultságod ládát bedobni.',
  'gifts.err.auth': 'Lejárt a bejelentkezésed. Jelentkezz be újra.',
  'gifts.err.rateLimited': 'Túl sok kérés egyszerre. Várj egy kicsit, és próbáld újra.',
  'gifts.err.network': 'Nem érjük el a szervert. Ellenőrizd a kapcsolatot, és próbáld újra.',
  'gifts.err.unavailable': 'Ez a funkció itt még nem érhető el.',
  'gifts.err.genericCode': 'Valami hiba történt ({code}). Próbáld újra.',
  'gifts.err.generic': 'Valami hiba történt. Próbáld újra.',
  'gifts.modal.prize': 'Nyeremény (nem kötelező)',
  'gifts.modal.prizeHint': 'Aki elkapja a ládát, ezeket a termékeidet kapja ingyen a kosarába (mindegyikből 1 db, legfeljebb {max} termék).',
  'gifts.modal.prizeAdd': 'Termék hozzáadása',
  'gifts.prize.label': 'Nyeremény',
  'gifts.prize.none': 'Nyeremény nélkül',
  'gifts.prize.freeShip': 'ingyenes szállítással',
  'gifts.col.prize': 'Nyeremény',
  'gifts.err.freeShipping': 'A termékes ládához fogadd el, hogy a szállítás ingyenes (a költségét te állod).',
  'gifts.err.product.product_not_found': 'Az egyik termék nem található. Válaszd ki újra a termékeket.',
  'gifts.err.product.product_inactive': 'Az egyik termék nem aktív, ezért nem lehet nyeremény.',
  'gifts.err.product.product_out_of_stock': 'Az egyik termék elfogyott, ezért nem lehet nyeremény.',
  'gifts.err.product.duplicate_product': 'Ugyanaz a termék kétszer szerepel.',
  'gifts.err.product.too_many_products': 'Egy ládában legfeljebb 5 termék lehet.',
  // ---- Challenges: prize wheel (Szerencsekerék) + the game switcher ----
  'games.label': 'Játékok',
  'games.gifts.title': 'Ajándékláda',
  'games.gifts.text': 'Átúszik a galaxison — aki elkapja, viszi',
  'games.wheel.title': 'Szerencsekerék',
  'games.wheel.text': 'A boltod mellett, élő sorsolással',
  'wheel.title': 'Szerencsekerék',
  'wheel.lead': 'Ütemezz egy nyereményjátékot a termékeiddel: a kerék a boltod mellett áll az Outfino térképén, a felhasználók az appban csatlakoznak, a sorsolást pedig te indítod el élőben — igazságosan és ellenőrizhetően.',
  'wheel.scheduleButton': 'Szerencsekerék ütemezése',
  'wheel.oneAtATime': 'Egyszerre egy aktív szerencsekereked lehet. Újat akkor ütemezhetsz, ha ezt kisorsoltuk vagy visszavontad.',
  'wheel.scheduled': 'Ütemezve! A kerék megjelent a boltod mellett a térképen.',
  'wheel.updated': 'A változásokat elmentettük.',
  'wheel.cancelled': 'A szerencsekereket visszavontad.',
  'wheel.currentTitle': 'Aktuális kerék',
  'wheel.pollingTitle': 'Az oldal magától frissül: gyakrabban, amíg a kerék ütemezve van vagy pörög.',
  'wheel.noActive': 'Most nincs szerencsekereked a térképen.',
  'wheel.historyTitle': 'Korábbi kerekek',
  'wheel.noHistory': 'Még nincs korábbi szerencsekereked.',
  'wheel.status.scheduled': 'Ütemezve',
  'wheel.status.drawing': 'Sorsolás folyamatban',
  'wheel.status.finished': 'Lezárult',
  'wheel.status.cancelled': 'Visszavonva',
  'wheel.opensAtChip': 'Csatlakozás: {at}',
  'wheel.joinOpen': 'Csatlakozás nyitva',
  'wheel.edit': 'Szerkesztés',
  'wheel.cancel': 'Visszavonás',
  'wheel.stat.untilDraw': 'Sorsolásig',
  'wheel.stat.spinEnds': 'A sorsolás végéig',
  'wheel.stat.drawnAt': 'Kisorsolva',
  'wheel.stat.participants': 'Résztvevők',
  'wheel.stat.winners': 'Nyertesek',
  'wheel.stat.opensIn': 'Csatlakozásig',
  'wheel.drawingNow': 'Az appban most pörög a kerék.',
  'wheel.countdownDays': '{d} nap {hms}',
  'wheel.lock.joined': 'Már csatlakoztak a kerékhez, ezért nem szerkeszthető; visszavonni még lehet.',
  'wheel.lock.soon': 'A sorsolás előtti utolsó 10 percben már nem szerkeszthető.',
  'wheel.lock.generic': 'Ez a kerék már nem szerkeszthető.',
  'wheel.winnersTitle': 'Nyertesek',
  'wheel.winnersError': 'A nyerteseket most nem sikerült betölteni.',
  'wheel.noParticipants': 'Senki nem csatlakozott, így nem volt nyertes.',
  'wheel.noWinners': 'Nincs nyertes.',
  'wheel.noWinnersShort': 'Nincs',
  'wheel.winnersN': '{n} nyertes',
  'wheel.someone': 'Valaki',
  'wheel.anonymous': 'privát profil',
  'wheel.round': '{n}. kör',
  'wheel.entryIndexTitle': 'A nyertes pont sorszáma a keréken (0-tól)',
  'wheel.details': 'Részletek',
  'wheel.cancelledAt': 'Visszavonva: {at}. Nem volt sorsolás.',
  'wheel.proof.title': 'Ellenőrizhető sorsolás',
  'wheel.proof.seedHash': 'Ujjlenyomat (seed hash)',
  'wheel.proof.seed': 'Titkos kulcs (seed)',
  'wheel.proof.seedHidden': 'A sorsolás után jelenik meg',
  'wheel.proof.textScheduled': 'Az ujjlenyomatot már az ütemezéskor rögzítettük; a hozzá tartozó titkos kulcsot a sorsolás után tesszük közzé, így az eredményt utólag senki nem igazíthatja.',
  'wheel.proof.textFinished': 'A titkos kulcs már nyilvános: bárki ellenőrizheti, hogy az ujjlenyomata egyezik, és hogy belőle ugyanezek a nyertesek jönnek ki.',
  'wheel.proof.check': 'Ellenőrzés most',
  'wheel.proof.checking': 'Ellenőrzés…',
  'wheel.proof.ok': 'Egyezik: az ujjlenyomat és a nyertesek is stimmelnek.',
  'wheel.proof.okHash': 'Az ujjlenyomat egyezik.',
  'wheel.proof.badHash': 'Az ujjlenyomat nem egyezik a kulccsal.',
  'wheel.proof.badWinners': 'A kulcsból más nyertesek jönnek ki.',
  'wheel.proof.checkError': 'Ebben a böngészőben most nem tudjuk ellenőrizni.',
  'wheel.proof.copy': '{what} másolása',
  'wheel.proof.howTitle': 'Hogyan ellenőrizhető?',
  'wheel.proof.how1': 'Ütemezéskor a szerver egy 32 bájtos véletlen kulcsot sorsol, és csak az SHA-256 ujjlenyomatát teszi közzé.',
  'wheel.proof.how2': 'A sorsoláskor a résztvevők a csatlakozás sorrendjében 0-tól kapnak sorszámot.',
  'wheel.proof.how3': 'Körönként a nyertes sorszáma ebből jön (torzításmentes választással, a korábbi nyertesek kizárásával):',
  'wheel.proof.how3Code': 'HMAC-SHA256(kulcs, "{id}:<kör>:<próba>")',
  'wheel.cancelTitle': 'Visszavonod a szerencsekereket?',
  'wheel.cancelText': 'A(z) „{title}” kerék azonnal eltűnik a térképről, és a {at} időpontra tervezett sorsolás elmarad. Ez nem vonható vissza.',
  'wheel.cancelJoined': 'Már {n} felhasználó csatlakozott.',
  'wheel.cancelling': 'Visszavonás…',
  'wheel.cancelConfirm': 'Igen, visszavonom',
  'wheel.form.createTitle': 'Szerencsekerék ütemezése',
  'wheel.form.editTitle': 'Szerencsekerék szerkesztése',
  'wheel.form.back': 'Mégse',
  'wheel.form.title': 'Cím',
  'wheel.form.titlePlaceholder': 'Pl. Őszi kollekció sorsolás',
  'wheel.form.titlePreview': 'A kerék címe',
  'wheel.form.prize': 'Nyeremény',
  'wheel.form.prizePlaceholder': 'Pl. 1 db táska az őszi kollekcióból, ingyenes szállítással',
  'wheel.form.winners': 'Nyertesek száma',
  'wheel.form.winnersHint': '1–{max} nyertes; egymás után sorsoljuk ki őket.',
  'wheel.form.winnersLocked': 'Ütemezés után nem módosítható.',
  'wheel.form.less': 'Kevesebb',
  'wheel.form.more': 'Több',
  'wheel.form.opens': 'Csatlakozás kezdete',
  'wheel.form.opensNow': 'Azonnal',
  'wheel.form.opensLater': 'Későbbi időpontban',
  'wheel.form.opensDate': 'A csatlakozás napja',
  'wheel.form.opensTime': 'A csatlakozás órája',
  'wheel.form.draw': 'Sorsolás időpontja',
  'wheel.form.drawDate': 'A sorsolás napja',
  'wheel.form.drawTime': 'A sorsolás órája',
  'wheel.form.quick.inHour': '1 óra múlva',
  'wheel.form.quick.tomorrow': 'Holnap 20:00',
  'wheel.form.quick.week': '1 hét múlva, 20:00',
  'wheel.form.drawHint': 'Legalább 10 perccel a csatlakozás kezdete után, legfeljebb 30 nappal előre.',
  'wheel.form.rules': 'Elfogadom a játékszabályzatot',
  'wheel.form.rulesHint': 'A sorsolás az Outfino játékszabályzata szerint zajlik; ütemezés előtt el kell fogadnod.',
  'wheel.form.schedule': 'Ütemezés',
  'wheel.form.scheduling': 'Ütemezés…',
  'wheel.form.save': 'Mentés',
  'wheel.form.saving': 'Mentés…',
  'wheel.form.fix': 'Nézd át a pirossal jelölt mezőket.',
  'wheel.form.err.titleRequired': 'Adj címet a keréknek.',
  'wheel.form.err.titleTooLong': 'Legfeljebb 80 karakter.',
  'wheel.form.err.prizeRequired': 'Írd le, mit lehet nyerni.',
  'wheel.form.err.prizeTooLong': 'Legfeljebb 500 karakter.',
  'wheel.form.err.winners': '1 és 10 közötti szám.',
  'wheel.form.err.opensRequired': 'Add meg a csatlakozás kezdetét.',
  'wheel.form.err.drawRequired': 'Add meg a sorsolás napját és óráját.',
  'wheel.form.err.drawTooSoon': 'A sorsolás legalább 10 perccel a csatlakozás kezdete után legyen.',
  'wheel.form.err.drawTooLate': 'Legfeljebb 30 nappal előre ütemezhetsz.',
  'wheel.form.err.rules': 'Az ütemezéshez fogadd el a játékszabályzatot.',
  'wheel.form.err.server': 'A szerver ezt a mezőt nem fogadta el.',
  'wheel.how.mapTitle': 'A térképen.',
  'wheel.how.map': 'Ütemezés után a kerék megjelenik a boltod mellett az Outfino térképén.',
  'wheel.how.joinTitle': 'Csatlakozás az appban.',
  'wheel.how.join': 'A felhasználók az appban csatlakoznak, a csatlakozás kezdetétől a sorsolásig — a beállításod szerint mindenki vagy csak a követőid.',
  'wheel.how.drawTitle': 'Élő sorsolás.',
  'wheel.how.draw': 'A sorsolás időpontjában te indítod el a kereket (akár élő adásban); az eredmény ellenőrizhető.',
  'wheel.preview.countLabel': 'résztvevő',
  'wheel.preview.label': '{name} szerencsekereke 3D-ben',
  'wheel.preview.hint': 'Húzd a forgatáshoz',
  'wheel.preview.spin': 'Próbapörgetés',
  'wheel.preview.spinning': 'Pörög…',
  'wheel.preview.noGl': 'A 3D előnézethez WebGL kell.',
  'wheel.preview.error': 'Az előnézetet most nem sikerült betölteni.',
  'wheel.preview.drawChip': 'Sorsolás: {at}',
  'wheel.preview.caption': 'Előnézet a márkád színeivel. A pontok a csatlakozókat jelölik (itt példaként {n}).',
  'wheel.col.drawAt': 'Sorsolás',
  'wheel.col.wheel': 'Kerék',
  'wheel.col.status': 'Állapot',
  'wheel.col.participants': 'Résztvevők',
  'wheel.col.winners': 'Nyertesek',
  'wheel.col.details': 'Részletek',
  'wheel.err.activeExists': 'Egyszerre csak egy aktív szerencsekereked lehet. A meglévőt sorsoljuk ki, vagy vond vissza, és utána ütemezhetsz újat.',
  'wheel.err.locked': 'Ez a kerék már nem szerkeszthető: csatlakoztak hozzá, vagy közel a sorsolás.',
  'wheel.err.notCancellable': 'Ezt a kereket már nem lehet visszavonni — a sorsolás elindult vagy lezárult.',
  'wheel.err.notFound': 'Ez a szerencsekerék nem található.',
  'wheel.err.invalid': 'Valami nem stimmel az űrlapon. Nézd át, és próbáld újra.',
  'wheel.err.invalidField': 'A szerver nem fogadta el ezt a mezőt: {field}.',
  'wheel.err.brandInactive': 'A márkád most nem látható az Outfinón, ezért nem ütemezhet szerencsekereket.',
  'wheel.err.notEligible': 'Ez a márka most nem ütemezhet szerencsekereket.',
  'wheel.err.disabled': 'A szerencsekerék most nem érhető el.',
  'wheel.err.forbidden': 'Nincs jogosultságod szerencsekereket kezelni ennél a márkánál.',
  'wheel.err.brandNotFound': 'Ez a márka nem található.',
  'wheel.err.auth': 'Lejárt a bejelentkezésed. Jelentkezz be újra.',
  'wheel.err.rateLimited': 'Túl sok kérés egyszerre. Várj egy kicsit, és próbáld újra.',
  'wheel.err.network': 'Nem érjük el a szervert. Ellenőrizd a kapcsolatot, és próbáld újra.',
  'wheel.err.unavailable': 'Ez a funkció itt még nem érhető el.',
  'wheel.err.genericCode': 'Valami hiba történt ({code}). Próbáld újra.',
  'wheel.err.generic': 'Valami hiba történt. Próbáld újra.',
  'wheel.free.accept': 'Tudomásul veszem: a nyertes a terméket és a szállítást is ingyen kapja, a szállítás költségét én állom.',
  'wheel.form.err.freeShipping': 'Az ütemezéshez fogadd el az ingyenes szállítást.',
  'wheel.form.err.roundTooMany': 'Egy körben legfeljebb 5 különböző termék lehet.',
  'wheel.form.productOut': 'Nem elérhető',
  'wheel.err.rounds.product_not_found': 'A(z) {round}. kör egyik terméke nem található.',
  'wheel.err.rounds.product_inactive': 'A(z) {round}. kör egyik terméke nem aktív.',
  'wheel.err.rounds.product_out_of_stock': 'A(z) {round}. kör egyik terméke elfogyott.',
  'wheel.err.rounds.duplicate_product': 'A(z) {round}. körben kétszer szerepel ugyanaz a termék.',
  'wheel.err.rounds.too_many_products': 'A(z) {round}. körben túl sok a termék (legfeljebb 5).',
  'wheel.err.rounds.empty_round': 'A(z) {round}. kör üres.',
  'wheel.err.rounds.too_many_rounds': 'Legfeljebb 10 kör lehet.',
  'wheel.status.ready': 'Sorsolásra kész',
  'wheel.free.title': 'Ingyenes nyeremény, ingyenes szállítás.',
  'wheel.free.text': 'A nyertes a terméke(ke)t ingyen kapja a kosarába, és a szállítás is kötelezően ingyenes — a szállítás költségét te állod.',
  'wheel.form.rounds': 'Nyeremények körönként',
  'wheel.form.roundsHint': 'Minden kör egy pörgetés és egy nyertes, aki a kör összes termékét megkapja (mindegyikből 1 db, körönként legfeljebb 5 termék). Legfeljebb 10 kör. Csak aktív, raktáron lévő termék lehet nyeremény.',
  'wheel.form.roundAdd': 'Kör hozzáadása',
  'wheel.form.roundUp': '{n}. kör feljebb',
  'wheel.form.roundDown': '{n}. kör lejjebb',
  'wheel.form.roundRemove': '{n}. kör törlése',
  'wheel.form.roundEmptyHint': 'Még nincs termék',
  'wheel.form.productsN': '{n} termék',
  'wheel.form.productsAdd': 'Termékek hozzáadása',
  'wheel.form.productsEdit': 'Termékek módosítása',
  'wheel.form.productSearch': 'Keresés a termékeid között',
  'wheel.form.productsPicked': '{n}/{max} kiválasztva',
  'wheel.form.productsDone': 'Kész',
  'wheel.form.productsNone': 'Még nincs terméked az Outfinón. Szinkronizáld őket a Termékek oldalon.',
  'wheel.form.productsNoMatch': 'Nincs ilyen termék.',
  'wheel.form.productsError': 'A termékeidet most nem sikerült betölteni.',
  'wheel.form.productRemove': '{name} eltávolítása',
  'wheel.form.exclude': 'Aki egy korábbi körben nyert, ne nyerhessen újra',
  'wheel.form.excludeHint': 'Így minden kör más nyertest kap.',
  'wheel.form.prizeOptional': 'Leírás (nem kötelező)',
  'wheel.form.prizeAutoHint': 'Ha üresen hagyod, a termékekből állítjuk össze.',
  'wheel.form.autoSummaryRound': '{n}. kör: {names}',
  'wheel.form.eligibility': 'Kik nevezhetnek?',
  'wheel.eligibility.followers_at_schedule': 'Csak a jelenlegi követők',
  'wheel.eligibility.followers_at_scheduleHint': 'Akik már most követnek; az új követők kizárva.',
  'wheel.eligibility.followers': 'Követők',
  'wheel.eligibility.followersHint': 'Új követők is nevezhetnek.',
  'wheel.eligibility.everyone': 'Mindenki',
  'wheel.eligibility.everyoneHint': 'Követéstől függetlenül bárki nevezhet.',
  'wheel.excludeOn': 'Egy ember egyszer nyerhet',
  'wheel.excludeOff': 'Többször is lehet nyerni',
  'wheel.form.err.roundsCount': '1 és 10 közötti kör kell.',
  'wheel.form.err.roundEmpty': 'Minden körbe tegyél legalább egy terméket.',
  'wheel.form.err.eligibility': 'Válaszd ki, kik nevezhetnek.',
  'wheel.preview.roundsChip': '{n} kör',
  'wheel.stat.rounds': 'Körök',
  'wheel.stat.autoStart': 'Automatikus indulásig',
  'wheel.readyNow': 'A csatlakozás lezárult — indítsd el a sorsolást!',
  'wheel.prizesTitle': 'Nyeremények',
  'wheel.resultsTitle': 'Eredmények körönként',
  'wheel.noWinnerRound': 'Nem volt nyertes',
  'wheel.live.ready': 'Sorsolásra kész',
  'wheel.live.start': 'Sorsolás indítása',
  'wheel.live.starting': 'Indítás…',
  'wheel.live.waiting': 'A sorsolást a márka indítja el.',
  'wheel.live.auto': 'Ha 30 mp-en belül nem indítod, automatikusan elindul ({s} mp).',
  'wheel.live.startsIn': 'Indul: {s} mp',
  'wheel.live.spinning': '{n}. kör / {total} — pörög',
  'wheel.live.roundWinner': '{n}. kör nyertese',
  'wheel.live.done': 'A sorsolás véget ért',
  'wheel.live.fullscreen': 'Teljes képernyő',
  'wheel.live.exitFullscreen': 'Kilépés',
  'wheel.err.notReady': 'A sorsolás még nem indítható.',
  'wheel.err.alreadyDrawn': 'A sorsolás már elindult.',
  'wheel.err.products': 'Valamelyik termék nem használható nyereményként. Nézd át a köröket.',
  'wheel.err.socket': 'Nincs élő kapcsolat a szerverrel. Próbáld újra; ha nem indítod, 30 mp után magától elindul.',
  // ---- Dev banner ----
  'dev.bannerFull': 'Fejlesztői mód — az éles verzióhoz látogass el ide: ',
  'dev.bannerShort': 'Fejlesztői mód — ',
  'dev.userBannerFull': 'Fejlesztői mód — dev felhasználóként vagy bejelentkezve',
  'dev.userBannerShort': 'Dev felhasználó',

  'tab.discounts': "Kedvezmények",
  'discounts.title': "Kedvezmények",
  'discounts.subtitle': "Automatikus kedvezmények és kuponkódok az Outfino vásárlóinak. Minden a Shopify boltodban is létrejön, és szinkronban marad vele.",
  'discounts.new': "Új kedvezmény",
  'discounts.section.automatic': "Automatikus kedvezmények",
  'discounts.section.code': "Kuponok",
  'discounts.empty.automatic': "Még nincs automatikus kedvezmény.",
  'discounts.empty.code': "Még nincs kupon. Hozz létre egy kódot, amit a vásárlók a kosárban beírhatnak.",
  'discounts.sync': "Szinkronizálás a Shopifyjal",
  'discounts.syncing': "Szinkronizálás…",
  'discounts.synced': "A kedvezmények szinkronban vannak a Shopifyjal.",
  'discounts.created': "{code} létrehozva a Shopifyban és az Outfinóban.",
  'discounts.pause': "Szüneteltetés",
  'discounts.resume': "Folytatás",
  'discounts.delete': "Törlés",
  'discounts.confirmDelete': "Törlöd: {code}? A Shopify boltodból is törlődik.",
  'discounts.usage': "{used}× használva",
  'discounts.usageOf': "{used} / {limit} használva",
  'discounts.minSubtotal': "{amount} felett",
  'discounts.minQuantity': "{n} darabtól",
  'discounts.allProducts': "Minden termék",
  'discounts.productCount': "{n} termék",
  'discounts.oncePerCustomer': "Vásárlónként egyszer",
  'discounts.fromShopify': "Shopifyból",
  'discounts.method.automatic': "Automatikus kedvezmény",
  'discounts.method.code': "Kuponkód",
  'discounts.status.active': "Aktív",
  'discounts.status.scheduled': "Ütemezett",
  'discounts.status.paused': "Szüneteltetve",
  'discounts.status.expired': "Lejárt",
  'discounts.status.used_up': "Elfogyott",
  'discounts.form.titleCoupon': "Új kupon",
  'discounts.form.kind': "Fajta",
  'discounts.form.shopify': "Shopify",
  'discounts.form.shopifySync': "Szinkron a Shopifyjal",
  'discounts.form.shopifyLocal': "Csak Outfino",
  'discounts.form.localNote': "A kedvezmény csak az Outfinón működik, a Shopify boltodban nem jön létre. A kifizetésedből ugyanúgy levonódik.",
  'discounts.syncedShopify': "Shopifyjal szinkronban",
  'discounts.outfinoOnly': "Csak Outfino",
  'discounts.createdLocal': "{code} létrehozva az Outfinón.",
  'discounts.confirmDeleteLocal': "Törlöd: {code}?",
  'discounts.currency': "Bolt pénzneme: {currency}",
  'discounts.form.title': "Új kedvezmény",
  'discounts.form.close': "Bezárás",
  'discounts.form.methodHint.automatic': "Fizetéskor automatikusan érvényesül, ha a feltételek teljesülnek — a vásárlónak nem kell kódot beírnia.",
  'discounts.form.methodHint.code': "A vásárló a kosárban írja be a kódot.",
  'discounts.form.code': "Kód",
  'discounts.form.codeHint': "3–32 karakter: betűk, számok, - és _",
  'discounts.form.name': "Név",
  'discounts.form.nameHint': "A vásárlók a kosárban látják",
  'discounts.form.namePlaceholder': "pl. Őszi akció",
  'discounts.form.type': "Típus",
  'discounts.form.typePercentage': "Százalékos",
  'discounts.form.typeFixed': "Fix összeg",
  'discounts.form.valuePercent': "Kedvezmény (%)",
  'discounts.form.valueAmount': "Kedvezmény összege ({currency})",
  'discounts.form.products': "Termékek",
  'discounts.form.allProducts': "Minden termék",
  'discounts.form.searchProducts': "Termékek keresése…",
  'discounts.form.noProducts': "Még nincs termék.",
  'discounts.form.selected': "{n} kiválasztva",
  'discounts.form.condition': "Feltétel",
  'discounts.form.conditionNone': "Nincs",
  'discounts.form.conditionSubtotal': "Minimum összeg",
  'discounts.form.conditionQuantity': "Minimum darab",
  'discounts.form.minSubtotal': "Minimum vásárlás ({currency})",
  'discounts.form.minQuantity': "Minimum darabszám",
  'discounts.form.usageLimit': "Összes felhasználás",
  'discounts.form.optional': "Opcionális",
  'discounts.form.startsAt': "Kezdete",
  'discounts.form.startsHint': "Üres = azonnal",
  'discounts.form.endsAt': "Vége",
  'discounts.form.oncePerCustomer': "Vásárlónként egyszer",
  'discounts.form.shopifyNote': "A kedvezmény a Shopify boltodban is létrejön, és a kifizetésedből vonódik le.",
  'discounts.form.cancel': "Mégse",
  'discounts.form.create': "Létrehozás",
  'discounts.form.creating': "Létrehozás…",
  'discounts.error.taken': "Ez a kód már létezik.",
  'discounts.error.invalid': "A Shopify elutasította a kedvezményt. Ellenőrizd az értékeket, és próbáld újra.",
  'discounts.error.reauth': "Az Outfinónak engedély kell a kedvezmények kezeléséhez a Shopify boltodban. Nyisd meg az Outfino appot a Shopifyban, és hagyd jóvá a frissített jogosultságokat.",
  'discounts.error.createFailed': "Nem sikerült létrehozni a kedvezményt. Próbáld újra.",
  'discounts.error.syncFailed': "Nem sikerült szinkronizálni a Shopifyjal. Próbáld újra.",
  'discounts.error.updateFailed': "Nem sikerült módosítani a kedvezményt. Próbáld újra.",
  'discounts.error.deleteFailed': "Nem sikerült törölni a kedvezményt. Próbáld újra.",

  // ── Fit-check embed (Statisztikák / Látogatók / Beállítások) ──
  'tab.embedded-settings': 'Beállítások',
  'embed.range.label': 'Időszak',
  'embed.range.days': '{n} nap',
  'embed.range.custom': 'Egyéni',
  'embed.range.from': 'Kezdete',
  'embed.range.to': 'Vége',
  'embed.mock.badge': 'Tesztadatok',
  'embed.mock.title': 'Ezek tesztadatok, nem valódi forgalom.',
  'embed.error.load': 'Nem sikerült betölteni az adatokat. Próbáld újra a Frissítés gombbal.',
  'embed.error.forbidden': 'Ehhez az oldalhoz nincs jogosultságod ennél a márkánál.',
  'embed.empty.range': 'Ebben az időszakban még nincs adat.',
  'embed.copy.button': 'Másolás',
  'embed.copy.codeDone': 'A beágyazó kód a vágólapon van',
  'embed.copy.failed': 'Nem sikerült a másolás. Jelöld ki a kódot, és másold kézzel.',

  'embed.stats.title': 'Fit-check gomb statisztika',
  'embed.stats.lead': 'Mit csinált a „Nézd meg, hogy passzol-e hozzád” gomb a termékoldalaidon: hányan látták, kattintottak, léptek be, töltöttek fel fotót és nézték meg a product matchinget.',
  'embed.kpi.impressions': 'Megjelenések',
  'embed.kpi.clicks': 'Kattintások',
  'embed.kpi.signups': 'Regisztrációk',
  'embed.kpi.logins': 'Belépések',
  'embed.kpi.matchViews': 'Matching megtekintések',
  'embed.kpi.uploadSessions': 'Feltöltések',
  'embed.kpi.photosUploaded': 'Feltöltött fotók',
  'embed.kpi.uniqueVisitors': 'Egyedi látogatók',
  'embed.kpi.ctr': 'Átkattintás: {pct}',
  'embed.kpi.perUpload': 'Átlag {n} fotó / feltöltés',
  'embed.funnel.title': 'Tölcsér',
  'embed.funnel.impressions': 'Megjelenés',
  'embed.funnel.clicks': 'Kattintás',
  'embed.funnel.signIns': 'Regisztráció vagy belépés',
  'embed.funnel.matchViews': 'Product matching megtekintés',
  'embed.funnel.conv': '{pct} az előző lépésből',
  'embed.funnel.signInsHint': '{signups} új · {logins} visszatérő',
  'embed.funnel.uploadSessions': 'feltöltés',
  'embed.funnel.photos': 'feltöltött fotó',
  'embed.funnel.uploadRate': 'a belépők közül töltött fel fotót',
  'embed.chart.title': 'Napi alakulás',
  'embed.chart.metricLabel': 'Mutató',
  'embed.chart.metric.impressions': 'Megjelenések',
  'embed.chart.metric.clicks': 'Kattintások',
  'embed.chart.metric.signIns': 'Regisztrációk + belépések',
  'embed.chart.metric.matchViews': 'Matching megtekintések',
  'embed.chart.metric.photosUploaded': 'Feltöltött fotók',
  'embed.chart.showTable': 'Napi bontás táblázatban',
  'embed.chart.hideTable': 'Táblázat elrejtése',
  'embed.chart.date': 'Nap',
  'embed.top.title': 'Termékek',
  'embed.top.lead': 'Melyik termékoldal hozta a regisztrációkat, a matching megtekintéseket és a feltöltött fotókat, és mennyire illettek a termékek a látogatókhoz.',
  'embed.top.product': 'Termék',
  'embed.top.col.impressions': 'Megjelenés',
  'embed.top.col.clicks': 'Kattintás',
  'embed.top.col.signups': 'Regisztráció',
  'embed.top.col.matchViews': 'Matching',
  'embed.top.col.photosUploaded': 'Fotó',
  'embed.top.col.avgCompatibility': 'Átl. kompatibilitás',

  'embed.visitors.title': 'Látogatók',
  'embed.visitors.lead': 'Ki mit csinált a gombbal, melyik termékednél. Csak a bejelentkezett Outfino-felhasználók szerepelnek itt; a névtelen kosarak és vásárlások a Statisztikák összesítőiben látszanak.',
  'embed.visitors.product': 'Termék',
  'embed.visitors.allProducts': 'Minden termék',
  'embed.visitors.event': 'Esemény',
  'embed.visitors.allEvents': 'Minden esemény',
  'embed.visitors.empty': 'Nincs a szűrésnek megfelelő látogató ebben az időszakban.',
  'embed.visitors.shown': '{n} esemény',
  'embed.visitors.more': 'Továbbiak betöltése',
  'embed.visitors.col.user': 'Felhasználó',
  'embed.visitors.col.event': 'Esemény',
  'embed.visitors.col.product': 'Termék',
  'embed.visitors.col.photos': 'Fotók',
  'embed.visitors.col.compat': 'Kompatibilitás',
  'embed.visitors.col.time': 'Időpont',
  'embed.event.signup': 'Regisztrált az Outfinóra',
  'embed.event.login': 'Belépett',
  'embed.event.match_view': 'Megnézte a product matchinget',
  'embed.event.uploadOne': '1 képet töltött fel',
  'embed.event.upload': '{n} képet töltött fel',
  'embed.eventFilter.signup': 'Regisztráció',
  'embed.eventFilter.login': 'Belépés',
  'embed.eventFilter.upload': 'Képfeltöltés',
  'embed.eventFilter.match_view': 'Product matching megtekintés',

  'embed.settings.title': 'Fit-check gomb beállításai',
  'embed.status.configured': 'Beállítva',
  'embed.status.notConfigured': 'Nincs beállítva',
  'embed.status.lastSeen': 'Utoljára élő oldalon: {ago}',
  'embed.status.notConfiguredHint': 'Az elmúlt 7 napban nem láttuk a gombot élő oldalon. Tedd ki az alábbi kóddal, és pár percen belül itt jelzünk.',
  'embed.status.domainMeta': '{ago} · {n} megjelenés az elmúlt 7 napban',
  'embed.key.label': 'Embed kulcs',
  'embed.key.masked': 'Embed kulcs, részben elrejtve',
  'embed.key.copyCode': 'Beágyazó kód másolása',
  'embed.key.allowed': 'A kulcs csak itt működik: {domains}',
  'embed.design.title': 'A gomb kinézete',
  'embed.design.lead': 'Válaszd ki, melyik illik a boltod témájához. Az előnézetek az élő gombot mutatják.',
  'embed.design.gallery': 'Forma és szín',
  'embed.design.shape.pill': 'Kapszula',
  'embed.design.shape.rounded': 'Lekerekített',
  'embed.design.shape.square': 'Szögletes',
  'embed.design.theme.dark': 'Sötét gomb',
  'embed.design.theme.light': 'Világos gomb',
  'embed.design.variant': 'Szélesség',
  'embed.design.variant.compact': 'Kompakt',
  'embed.design.variant.full': 'Teljes szélesség',
  'embed.design.height': 'Magasság',
  'embed.design.lang': 'Nyelv',
  'embed.design.lang.auto': 'Automatikus (ajánlott)',
  'embed.design.langNote': 'A gomb automatikusan a látogató nyelvén jelenik meg: magyar böngészőben magyarul, mindenhol máshol angolul. A kimásolt kódban ez az alapbeállítás (lang=auto).',
  'embed.design.langForced': 'A gomb minden látogatónak ezen a nyelven jelenik meg: {lang}. Az automatikus beállítással mindenki a saját nyelvén látja.',
  'embed.design.preview': 'Előnézet',
  'embed.design.visitor.hu': 'Magyar nyelvű látogató',
  'embed.design.visitor.en': 'Bármely más nyelvű látogató',
  'embed.install.title': 'Beépítés a boltba',
  'embed.install.platform': 'Platform',
  'embed.install.shopify': 'Shopify (Liquid)',
  'embed.install.html': 'Más webshop (HTML)',
  'embed.install.code': 'Beágyazó kód',
  'embed.install.liquid.title': 'Egyéni Liquid blokk',
  'embed.install.liquid.lead': 'Bármelyik Shopify témában működik, beillesztéssel.',
  'embed.install.liquid.step1': 'Shopify adminban: Online Store → Customize → Product page (Online áruház → Testreszabás → Termékoldal).',
  'embed.install.liquid.step2': 'Add block → Custom Liquid (Egyéni Liquid), oda, ahol a gombot szeretnéd (pl. a Kosárba gomb alá).',
  'embed.install.liquid.step3': 'Illeszd be az alábbi kódot, és mentsd.',
  'embed.install.liquid.vars': 'A kód a Shopify változóiból veszi a termék adatait: {{ product.id }}, {{ product.handle }} és a termék kiemelt képe. A bolt a Márkaprofilban megadott webshop címed.',
  'embed.install.html.step1': 'Másold ki az alábbi kódot.',
  'embed.install.html.step2': 'Illeszd be a termékoldal sablonjába, oda, ahol a gombot szeretnéd.',
  'embed.install.html.step3': 'Cseréld ki a helyőrzőket a termék adataira (a webshopod sablonnyelvének változóival).',
  'embed.install.ph.id': 'a termék azonosítója (csak számjegyek)',
  'embed.install.ph.handle': 'a termék URL-neve (pl. organic-cotton-tee)',
  'embed.install.ph.img': 'a termékkép https címe, URL-kódolva',

  // ── Fit-check embed: SRC, carts + purchases, the pixel ──
  'embed.copy.srcDone': 'Az SRC a vágólapon van',
  'embed.copy.snippetDone': 'Kimásolva: {what}',
  'embed.key.copySrc': 'SRC másolása',
  'embed.key.srcLabel': 'Iframe SRC · {platform}',
  'embed.kpi.addToCarts': 'Kosárba tétel',
  'embed.kpi.purchases': 'Vásárlás',
  'embed.kpi.revenueMatched': 'Bevétel matchinggel',
  'embed.kpi.ofWhichMatched': 'ebből matchinggel: {n}',
  'embed.kpi.revenueHint': 'Azok a vásárlások, ahol a vevő előtte megnézte a matchinget annál a terméknél',
  'embed.funnel.addToCartsMatched': 'Kosárba tette (matchinggel)',
  'embed.funnel.purchasesMatched': 'Megvásárolta (matchinggel)',
  'embed.funnel.allCarts': 'összes kosárba tétel: {n}',
  'embed.funnel.allPurchases': 'összes vásárlás: {n}',
  'embed.chart.metric.addToCarts': 'Kosárba tételek',
  'embed.chart.metric.purchases': 'Vásárlások',
  'embed.top.col.addToCarts': 'Kosárba',
  'embed.top.col.purchases': 'Vásárlás',
  'embed.top.col.revenueMatched': 'Bevétel',
  'embed.top.matched': '{n} matchinggel',
  'embed.event.add_to_cart': 'Kosárba tette',
  'embed.event.purchase': 'Megvásárolta',
  'embed.eventFilter.add_to_cart': 'Kosárba tétel',
  'embed.eventFilter.purchase': 'Vásárlás',
  'embed.visitors.qty': '{n} db',
  'embed.visitors.matched': 'matchinggel',
  'embed.visitors.matchedTitle': 'Előtte megnézte a product matchinget ennél a terméknél (30 napon belül)',
  'embed.tracking.title': 'Kosár- és vásárláskövetés',
  'embed.tracking.lead': 'Az Outfino pixel bármely webshopban méri a kosárba tételeket és a vásárlásokat. A statisztikában az összes szám a pixel által látott összes kosár és vásárlás (a névtelen látogatóké is); „matchinggel” az, ahol ugyanaz a látogató az előtte lévő 30 napban megnézte a product matchinget annál a terméknél. A Látogatók listában csak a bejelentkezett Outfino-felhasználók szerepelnek.',
  'embed.tracking.platform.shopify': 'Shopify',
  'embed.tracking.platform.woocommerce': 'WooCommerce',
  'embed.tracking.platform.html': 'Más webshop (HTML)',
  'embed.tracking.lastCart': 'Utolsó kosárba tétel: {ago}',
  'embed.tracking.lastPurchase': 'utolsó vásárlás: {ago}',
  'embed.tracking.notConfiguredHint': 'Még nem érkezett kosár- vagy vásárlásesemény. Kapcsold be az alábbiak szerint.',
  'embed.tracking.seenOn': 'Látott platform:',
  'embed.tracking.seen.shopify': 'Shopify',
  'embed.tracking.seen.woocommerce': 'WooCommerce',
  'embed.tracking.seen.custom': 'Egyedi',
  'embed.tracking.shopify.step1': 'Kosárba tétel minden oldalon: Online Store → Themes → Edit code (Online áruház → Témák → Kód szerkesztése) → theme.liquid. Illeszd be ezt a sort a </body> elé, majd mentsd.',
  'embed.tracking.shopify.step2': 'Vásárlások: Shopify adminban Settings → Customer events → Add custom pixel. Nevezd el „Outfino”-nak, és illeszd be ezt a kódot (a kulcsod már benne van).',
  'embed.tracking.woo.step1': 'Tedd be ezt a két sort minden oldalra, egyszer (pl. egy „header/footer scripts” bővítménnyel).',
  'embed.tracking.woo.step1b': 'Vagy bővítmény nélkül, a téma functions.php-jába:',
  'embed.tracking.woo.phpTitle': 'Opcionális: PHP-részlet a köszönőoldalra',
  'embed.tracking.woo.phpLead': 'A pontos tételekhez és értékhez, a téma functions.php-jába vagy egy kis bővítménybe. Nélküle a pixel a köszönőoldalról olvassa a rendelésszámot és a végösszeget.',
  'embed.tracking.html.step1': 'Tedd be ezt a két sort a webshop minden oldalára, a </head> elé.',
  'embed.tracking.html.step2': 'Kosárba tétel: vagy egy data-attribútum a kosár gombon, vagy egy hívás a saját kosárkódodból.',
  'embed.tracking.html.step3': 'Vásárlás: a rendelés-visszaigazoló oldalon, egyszer, a rendelés adataival.',
  'embed.tracking.code.pixel': 'Pixel',
  'embed.tracking.code.php': 'PHP-részlet',
  'embed.tracking.code.addToCart': 'Kosárba tétel',
  'embed.tracking.code.purchase': 'Vásárlás',
  'embed.tracking.code.consent': 'Hozzájárulás',
  'embed.tracking.consent': 'Az EU-ban a követés csak a látogató hozzájárulása után indulhat; előtte a pixel semmit nem tárol és nem küld. Automatikusan követi a Shopify Customer Privacy API-t, a WP Consent API-t, a Google Consent Mode-ot és az elterjedt cookie-kezelőket (Cookiebot, OneTrust, CookieYes). Ha egyik sincs az oldalon, a hozzájárulás után hívd meg (elutasításnál false-szal):',
  'embed.tracking.shopify.detects': 'Felismeri a téma AJAX-os és űrlapos kosárba tételét; a hozzájáruláshoz a Shopify Customer Privacy API-t használja.',
  'embed.tracking.woo.detects': 'Felismeri a listaoldali AJAX-os és a termékoldali kosárba tételt, a Cart/Checkout blokkokat, és a rendelés-visszaigazoló oldalt.',
  'embed.tracking.code.functions': 'functions.php',
  'embed.tracking.code.addToCartAttr': 'Kosár gomb (data-attribútum)',
  'embed.kpi.allSeen': 'a pixel által látott összes',
  'embed.tracking.shopify.step2b': 'Permission: Analytics, majd Save és Connect.',
  'embed.tracking.code.customPixel': 'Egyéni pixel',
  'embed.tracking.products': 'A termékeket a pixel magától olvassa ki az oldalról (Shopify katalógus, WooCommerce Store API, schema.org JSON-LD), így nincs szükség termékszinkronra.',
  'embed.kpi.follows': 'Új követők (iframe-ből)',
  'embed.funnel.follows': 'követés',
  'embed.chart.metric.follows': 'Új követők',
  'embed.top.col.follows': 'Követés',
  'embed.event.follow': 'Követni kezdte a márkát',
  'embed.eventFilter.follow': 'Követés',
  'embed.copy.keyDone': 'A kulcs a vágólapon van',
  'embed.key.copyKey': 'Kulcs másolása',
  'embed.install.block.title': 'Outfino app blokk',
  'embed.install.block.lead': 'Ha az Outfino Shopify app telepítve van, a gomb egy blokk a témaszerkesztőben.',
  'embed.install.block.step1': 'Shopify adminban: Online Store → Customize (Online áruház → Testreszabás).',
  'embed.install.block.step2': 'Felül válaszd a Product page (termékoldal) sablont, majd Add block → Outfino.',
  'embed.install.block.step3': 'A blokk „Embed key” mezőjébe illeszd be a kulcsodat.',
  'embed.install.block.step4': 'Állítsd be ugyanazt a formát, színt, szélességet és magasságot, amit fent választottál, majd mentsd.',
  'embed.tracking.app.title': 'Outfino app',
  'embed.tracking.app.lead': 'Ha az Outfino Shopify app telepítve van.',
  'embed.tracking.app.step1': 'Online Store → Customize → App embeds (Online áruház → Testreszabás → Alkalmazásbeágyazások).',
  'embed.tracking.app.step2': 'Kapcsold be az „Outfino követés” beágyazást, majd mentsd.',
  'embed.tracking.app.checkout': 'A pénztárban leadott rendeléseket az Outfino app Web Pixele automatikusan küldi.',
  'embed.tracking.paste.title': 'Beillesztéssel',
  'embed.tracking.paste.lead': 'App nélkül, bármelyik Shopify témában.',
  'embed.visitors.guest': 'Vendég',
  'embed.visitors.anonymous': 'Látogató',
  'embed.visitors.identified': 'Outfino-felhasználó',
  'embed.visitors.identifiedTitle': 'Bejelentkezett Outfino-felhasználó a gombban',
  'embed.visitors.matches': 'Matching ({n})',
  'embed.visitors.matchesShow': 'Matching eredmények megnyitása',
  'embed.visitors.matchesHide': 'Matching eredmények bezárása',
  'embed.visitors.matchesTitle': '{name} matching eredményei a termékeidnél',
  'embed.visitors.matchTitle': 'Product matching: {pct} egyezés ennél a terméknél',
  'embed.visitors.basis.percentile': 'A stílusához mért helyezés a hasonló termékek között',
  'embed.visitors.basis.absolute': 'Közvetlen stílus-hasonlóság alapján',
  'embed.visitors.reason.similar_to': 'Hasonló van a gardróbjában: {label}',
  'embed.visitors.reason.pairs_with': 'Jól passzol hozzá: {label}',
  'embed.visitors.reason.none': 'Nem volt kiemelhető hasonló darab a gardróbjában.',
  'embed.visitors.reason.notOpened': 'Rövid indoklás nincs: a részletes elemzést nem nyitotta meg.',
  'embed.visitors.sentenceTitle': 'Pontosan ezt a mondatot látta a vásárló a százalék alatt.',

  // ── KYC: „Kik nézik a termékeidet?” (aggregált demográfia) ──
  'embed.kyc.title': 'Kik nézik a termékeidet?',
  'embed.kyc.lead': 'A product matchinget megnyitó, bejelentkezett vásárlók összesített demográfiája. Csak csoportszintű arányok — egyetlen embert sem lehet beazonosítani belőle.',
  'embed.kyc.basedOn': '{n} vásárló alapján',
  'embed.kyc.lowData': 'Még kevés az adat. Az összesített demográfia csak legalább {min} bejelentkezett vásárló után jelenik meg, hogy senki ne legyen beazonosítható.',
  'embed.kyc.groupEmpty': 'Ehhez nincs elég adat.',
  'embed.kyc.age': 'Életkor',
  'embed.kyc.genderTitle': 'Nem',
  'embed.kyc.styleTitle': 'Jellemző stílus',
  'embed.kyc.unknown': 'Nincs megadva',
  'embed.kyc.gender.FEMALE': 'Nő',
  'embed.kyc.gender.MALE': 'Férfi',
  'embed.kyc.gender.unknown': 'Nincs megadva',
  'embed.kyc.maskedLabel': 'Kis csoportok (< {min})',
  'embed.kyc.maskedLt': '< {min}',
  'embed.kyc.maskedTitle': '{n} kategória el van rejtve, mert külön-külön túl kevés vásárlót tartalmaz.',
  'embed.kyc.privacyNote': 'Az adatvédelem érdekében a {min} vásárlónál kisebb csoportokat nem bontjuk tovább.',
  'embed.kyc.style.streetwear': 'Streetwear',
  'embed.kyc.style.techwear': 'Techwear',
  'embed.kyc.style.goth_alt': 'Goth / alternatív',
  'embed.kyc.style.experimental': 'Kísérletező',
  'embed.kyc.style.y2k': 'Y2K',
  'embed.kyc.style.sporty': 'Sportos',
  'embed.kyc.style.casual': 'Hétköznapi',
  'embed.kyc.style.boho_indie': 'Boho / indie',
  'embed.kyc.style.minimalist': 'Minimalista',
  'embed.kyc.style.old_money': 'Old money',
  'embed.kyc.style.vintage_retro': 'Vintage / retró',

  'embed.tracking.inactive': 'Nem aktív',
  'embed.tracking.inactiveHint': 'Az elmúlt 7 napban nem érkezett kosár- vagy vásárlásesemény.',
  'embed.product.untitled': 'Termék #{id}',

  // ── Profil / Követők / Számlázás (top-level brand pages) ──
  'tab.followers': 'Követők',
  'tab.billing': 'Számlázás',

  'brandProfile.title': 'Márkaprofil',
  'brandProfile.logo': 'Logó',
  'brandProfile.logoAdd': 'Logó hozzáadása',
  'brandProfile.logoChange': 'Logó cseréje',
  'brandProfile.logoHint': 'Kör alakban jelenik meg. Négyzetes kép mutat a legjobban.',
  'brandProfile.cover': 'Borítókép',
  'brandProfile.coverAdd': 'Borítókép hozzáadása',
  'brandProfile.coverChange': 'Borítókép cseréje',
  'brandProfile.nameRequired': 'A márkanév nem lehet üres.',
  'brandProfile.preview': 'Előnézet',
  'brandProfile.previewChip': 'A fit-check gombban',
  'brandProfile.previewHeader': 'Fejléc a borítóképpel',
  'brandProfile.tone.light': 'Világos',
  'brandProfile.tone.dark': 'Sötét',
  'brandProfile.follow': 'Követés',

  'followers.title': 'Követők',
  'followers.lead': 'Akik követik a márkát, az appból vagy a fit-check gombból.',
  'followers.count': 'követő',
  'followers.matches': 'találat',
  'followers.search': 'Keresés névre vagy felhasználónévre',
  'followers.empty': 'Még nincs követő.',
  'followers.noMatch': 'Nincs ilyen nevű követő.',
  'followers.col.user': 'Felhasználó',
  'followers.col.source': 'Honnan',
  'followers.col.since': 'Követés kezdete',
  'followers.source.app': 'Appból',
  'followers.source.embed': 'Fit-check gombból',
  'followers.anon': 'Névtelen követő',
  'followers.anonTitle': 'A felhasználó nem jelenik meg név szerint.',
  'followers.shown': '{n} / {total} látható',
  'followers.more': 'Továbbiak betöltése',

  // Push a követőidnek (brand → followers push)
  'followers.push.card.title': 'Push küldése a követőidnek',
  'followers.push.card.lead': 'Egy értesítést küldesz most minden követődnek. A szöveget te írod, úgy megy ki, ahogy beírtad.',
  'followers.push.open': 'Push írása',
  'followers.push.audience': '{n} követődnek megy ki',
  'followers.push.audienceOne': '1 követődnek megy ki',
  'followers.push.audienceNone': 'Még nincs követőd, akinek ki tudnánk küldeni.',
  'followers.push.titleLabel': 'Cím',
  'followers.push.titlePlaceholder': 'pl. Megérkezett az új kollekció',
  'followers.push.bodyLabel': 'Szöveg',
  'followers.push.bodyPlaceholder': 'Írd le röviden, miről értesíted a követőidet.',
  'followers.push.count': '{n} / {max}',
  'followers.push.previewLabel': 'Előnézet',
  'followers.push.previewEmptyTitle': 'Cím',
  'followers.push.previewEmptyBody': 'A push szövege itt jelenik meg.',
  'followers.push.send': 'Küldés most',
  'followers.push.sending': 'Küldés…',
  'followers.push.cancel': 'Mégse',
  'followers.push.confirmTitle': 'Elküldöd a követőidnek?',
  'followers.push.confirmBody': 'Biztosan elküldöd {n} követődnek? Ez nem vonható vissza.',
  'followers.push.confirmSend': 'Igen, küldés',
  'followers.push.quota': 'Ma még {n} / {cap} küldés maradt.',
  'followers.push.quotaNone': 'Mára elérted a napi {cap} küldést.',
  'followers.push.lastSent': 'Utoljára elküldve: {date}',
  'followers.push.lastSentNever': 'Még nem küldtél push-t.',
  'followers.push.scheduleHint': 'Időzített küldés hamarosan.',
  'followers.push.ok': 'Push elküldve {n} követődnek.',
  'followers.push.error': 'Nem sikerült elküldeni a push-t. Próbáld újra.',
  'followers.push.errorCap': 'Mára elérted a napi küldési korlátot. Próbáld újra később.',
  'followers.push.errorForbidden': 'Ehhez nincs jogosultságod, vagy a márka még nem látható az appban.',
  'followers.push.errorValidation': 'Töltsd ki a címet és a szöveget.',

  'billing.loadError': 'Nem sikerült betölteni a számlázási adatokat. Próbáld újra a Frissítés gombbal.',
  'billing.readOnly': 'A kártyát és a számlázási adatokat a márka tulajdonosa módosíthatja.',
  'billing.readOnlyOwner': 'A számlázást a márka tulajdonosa kezeli.',
  'billing.cancel': 'Mégse',
  'billing.term': 'egyedi matching',
  'billing.terms': 'egyedi matching',
  'billing.termTip': 'Egy felhasználó egy terméknél 30 napon belül egyszer számít.',
  'billing.price.title': 'Díjszabás',
  'billing.price.base': 'Havidíj: {fee} (az első hónap ingyenes)',
  'billing.price.included': '{n} {term} benne',
  'billing.price.overage': 'felette {price} / {term} (havonta legfeljebb {cap})',
  'billing.price.commission': '{rate} jutalék a matchinghez köthető vásárlásokból',
  'billing.usage.title': 'Ez a hónap',
  'billing.usage.period': 'Hónap',
  'billing.usage.includedOf': '{term}',
  'billing.usage.over': '+{n} a kereten felül',
  'billing.usage.meterLabel': 'Felhasznált egyedi matchingek a havidíjban foglaltakból',
  'billing.usage.baseFee': 'Havidíj',
  'billing.usage.trial': 'Próbahónap',
  'billing.usage.overage': 'Többlet-matching',
  'billing.usage.overageCalc': '{n} × {price}, legfeljebb {cap}',
  'billing.usage.overageNone': 'A havidíjban foglalt kereten belül (legfeljebb {cap})',
  'billing.usage.capReached': 'elérte a havi felső határt',
  'billing.usage.commission': 'Jutalék ({rate})',
  'billing.usage.commissionCalc': '{n} matchinghez köthető vásárlás, {revenue} forgalom',
  'billing.usage.estimated': 'Várható összeg',
  'billing.usage.total': 'A hónap összege',

  'billing.card.title': 'Bankkártya',
  'billing.card.lead': 'A havi díjat erről a kártyáról vonjuk le.',
  'billing.card.none': 'Még nincs kártya megadva.',
  'billing.card.generic': 'Kártya',
  'billing.card.expires': 'Lejárat: {date}',
  'billing.card.expired': 'Lejárt: {date}',
  'billing.card.add': 'Kártya hozzáadása',
  'billing.card.replace': 'Kártya cseréje',
  'billing.card.remove': 'Eltávolítás',
  'billing.card.removeConfirm': 'Eltávolítod a kártyát? Amíg nincs kártya megadva, a havi díjat nem tudjuk levonni.',
  'billing.card.removeYes': 'Eltávolítás',
  'billing.card.removing': 'Eltávolítás…',
  'billing.card.removed': 'A kártya eltávolítva',
  'billing.card.removeFailed': 'Nem sikerült eltávolítani a kártyát. Próbáld újra.',
  'billing.card.save': 'Kártya mentése',
  'billing.card.saving': 'Mentés…',
  'billing.card.saved': 'A kártya elmentve',
  'billing.card.saveFailed': 'A kártyát a bank elfogadta, de nem sikerült elmenteni. Próbáld újra.',
  'billing.card.failed': 'Nem sikerült hitelesíteni a kártyát. Próbáld újra, vagy adj meg másik kártyát.',
  'billing.card.processing': 'A bank még feldolgozza a kártyát. Pár perc múlva frissítsd az oldalt.',
  'billing.card.unavailable': 'A kártya megadása most nem érhető el. Próbáld újra később.',

  'billing.mock.note': 'Tesztmód: nincs Stripe-kapcsolat, semmi nem kerül terhelésre. Próbaszámok: 4242 4242 4242 4242 (sikeres), 4000 0027 6000 3184 (3D Secure), 4000 0000 0000 0002 (elutasított).',
  'billing.mock.number': 'Kártyaszám',
  'billing.mock.expiry': 'Lejárat',
  'billing.mock.expiryPh': 'HH / ÉÉ',
  'billing.mock.badNumber': 'Érvénytelen kártyaszám.',
  'billing.mock.badExpiry': 'Érvénytelen vagy lejárt dátum.',
  'billing.mock.badCvc': 'Érvénytelen CVC.',
  'billing.mock.declined': 'A kártyát a bank elutasította.',
  'billing.mock.3dsTitle': 'Hitelesítés a bankodnál',
  'billing.mock.3dsBody': 'A bankod megerősítést kér ehhez a kártyához (3D Secure).',
  'billing.mock.3dsApprove': 'Megerősítés',
  'billing.mock.3dsReject': 'Elutasítás',
  'billing.mock.3dsFailed': 'A 3D Secure hitelesítés nem sikerült. Próbáld újra, vagy adj meg másik kártyát.',

  'billing.details.title': 'Számlázási adatok',
  'billing.details.name': 'Cégnév',
  'billing.details.email': 'Számlázási e-mail',
  'billing.details.taxId': 'Adószám / közösségi adószám',
  'billing.details.taxIdPh': '12345678-2-42 vagy HU12345678',
  'billing.details.line1': 'Cím',
  'billing.details.line2': 'Cím, 2. sor',
  'billing.details.postalCode': 'Irányítószám',
  'billing.details.city': 'Település',
  'billing.details.country': 'Ország',
  'billing.details.save': 'Adatok mentése',
  'billing.details.saved': 'A számlázási adatok elmentve',
  'billing.details.saveFailed': 'Nem sikerült menteni a számlázási adatokat.',
  'billing.details.required': 'Kötelező mező.',
  'billing.details.badEmail': 'Érvénytelen e-mail-cím.',

  'billing.invoices.title': 'Számlák',
  'billing.invoices.empty': 'Még nincs számla.',
  'billing.invoices.number': 'Számlaszám',
  'billing.invoices.period': 'Időszak',
  'billing.invoices.amount': 'Összeg',
  'billing.invoices.status': 'Állapot',
  'billing.invoices.download': 'Letöltés',
  'billing.invoices.st.paid': 'Kifizetve',
  'billing.invoices.st.open': 'Fizetésre vár',
  'billing.invoices.st.draft': 'Előkészítés alatt',
  'billing.invoices.st.void': 'Érvénytelenítve',
  'billing.invoices.st.uncollectible': 'Sikertelen terhelés',

  // ── Kártya-kapu (REQUIRE_VALID_CARD) ──
  'gate.title.missing': 'Add meg a kártyádat a kezdéshez',
  'gate.title.expired': 'Lejárt a kártyád',
  'gate.title.failed': 'A legutóbbi levonás nem sikerült',
  'gate.lead.missing': 'A portál ellenőrzött bankkártyával érhető el. Az első hónap ingyenes.',
  'gate.lead.expired': 'A márkához mentett kártya lejárt. Adj meg egy új kártyát, és a portál újra elérhető.',
  'gate.lead.failed': 'A legutóbbi levonás nem sikerült erről a kártyáról. Adj meg egy új kártyát, és a portál újra elérhető.',
  'gate.current': 'Mentett kártya: •••• {last4}',
  'gate.newCard': 'Új kártya megadása',
  'gate.memberTitle': 'A portál még nem érhető el',
  'gate.member': 'A márka tulajdonosa még nem adott meg kártyát. Szólj neki, hogy a portál elérhető legyen.',
  'gate.otherBrand': 'Másik márka',
  'gate.notValid.missing': 'A kártya ellenőrzése nem sikerült. Próbáld újra, vagy adj meg másik kártyát.',
  'gate.notValid.expired': 'A kártya lejárt. Adj meg másik kártyát.',
  'gate.notValid.failed': 'A bank nem fogadta el a kártyát. Adj meg másik kártyát.',
  'gate.checkFailed': 'Nem sikerült ellenőrizni a kártyát. Próbáld újra.',
  'gate.adminBanner': 'Nincs érvényes kártya',
  'gate.status.missing': 'a márka még nem adott meg kártyát (adminként beléptél)',
  'gate.status.expired': 'a márka kártyája lejárt (adminként beléptél)',
  'gate.status.failed': 'a legutóbbi levonás nem sikerült (adminként beléptél)',
  'gate.errorTitle': 'Nem sikerült betölteni a számlázást',
  'gate.errorBody': 'Próbáld újra pár másodperc múlva.',
  'gate.retry': 'Újra',

  // ── A webshop címe (egy kulcs = egy oldal) ──
  'embed.domain.label': 'A webshop címe',
  'embed.domain.save': 'Cím mentése',
  'embed.domain.saved': 'Beállítva: {domain}',
  'embed.domain.change': 'Módosítás',
  'embed.domain.first': 'Előbb add meg a webshop címét a Márkaprofilban',
  'embed.domain.confirm': 'A gomb a régi oldalon ({from}) le fog állni, és ezután csak itt működik: {to}.',
  'embed.domain.confirmYes': 'Cím módosítása',
  'embed.domain.error.required': 'Add meg a webshop címét.',
  'embed.domain.error.path': 'Csak a cím kell (pl. nova-atelier.hu), útvonal, port és paraméter nélkül.',
  'embed.domain.error.invalid': 'Ez nem nyilvános webcím. Példa: nova-atelier.hu',
  'embed.domain.error.saveFailed': 'Nem sikerült menteni. Próbáld újra.',
  'embed.domain.error.forbidden': 'Ehhez nincs jogosultságod ennél a márkánál.',

  // ── Hibaüzenetek ──
  'embed.copy.mockLocked': 'Tesztadatokkal nem másolható kód — a valódi kulcs a portál éles adataiból jön.',
  'embed.copy.badKey': 'A kulcs formátuma hibás, ezért a kód nem másolható. Frissítsd az oldalt.',

  // ── Oldalhiba (PageErrorBoundary) ──
  'pageError.title': 'Ezt az oldalt most nem sikerült megjeleníteni',
  'pageError.body': 'Váratlan hiba történt. Töltsd újra az oldalt, vagy válassz másik oldalt a menüből.',
  'pageError.reload': 'Újratöltés',

  // ---- Új márka (onboarding, no Shopify) + Dropok (manual products) ----
  'shell.newBrand': 'Új márka',
  'onboarding.steps': 'A létrehozás lépései',
  'onboarding.step.brand': 'Márka adatai',
  'onboarding.step.card': 'Kártya',
  'onboarding.title': 'Új márka létrehozása',
  'onboarding.lead': 'Ezek jelennek meg a márkád oldalán és a fit-check gombnál. Utána megadod a kártyát, és indul az 1 hónapos ingyenes próbaidő.',
  'onboarding.namePlaceholder': 'A márkád neve',
  'onboarding.coverEmpty': 'Borítókép (széles kép)',
  'onboarding.coverAdd': 'Borítókép feltöltése',
  'onboarding.coverChange': 'Borítókép cseréje',
  'onboarding.logoAdd': 'Logó feltöltése',
  'onboarding.logoChange': 'Logó cseréje',
  'onboarding.mediaHint': 'Logó (kerek) és borítókép: JPEG, PNG vagy WebP, legfeljebb 10 MB.',
  'onboarding.name': 'Márkanév',
  'onboarding.domain': 'A webshop címe',
  'onboarding.domainHint': 'Csak a cím, pl. nova-atelier.hu. A fit-check gomb és a kulcs csak ezen az oldalon működik; később a Beállítások → Márkaprofilban módosíthatod.',
  'onboarding.domainSavedAs': 'Így mentjük: {domain}',
  'onboarding.termsBefore': 'Elfogadom az Outfino ',
  'onboarding.termsLink': 'partneri ÁSZF-ét',
  'onboarding.termsAfter': '.',
  'onboarding.submit': 'Márka létrehozása',
  'onboarding.creating': 'Létrehozás…',
  'onboarding.fine': 'A következő lépésben adod meg a kártyát.',
  'onboarding.shopify': 'Shopify boltod van?',
  'onboarding.shopifyLink': 'Csatlakoztasd a Shopifyt',
  'onboarding.cancel': 'Vissza',
  'onboarding.card.title': 'Kártya megadása – 1 hónap ingyenes próbaidő indul',
  'onboarding.card.lead': 'Az első hónap ingyenes. A próbaidő a kártya ellenőrzésével indul, utána havonta erről a kártyáról vonjuk le a díjat.',
  'onboarding.trialStarted': 'A próbaidőd elindult',
  'onboarding.error.limit': 'Elérted a létrehozható márkák számát. Ha újabb márkát indítanál, írj nekünk.',
  'onboarding.error.rateLimited': 'Túl sok próbálkozás. Próbáld újra egy óra múlva.',
  'onboarding.error.rateLimitedFor': 'Túl sok próbálkozás. Próbáld újra {min} perc múlva.',
  'onboarding.error.guest': 'Vendégfiókkal nem hozható létre márka. Jelentkezz be a saját fiókoddal.',
  'onboarding.error.signedOut': 'Lejárt a bejelentkezésed. Jelentkezz be újra.',
  'onboarding.error.failed': 'Nem sikerült létrehozni a márkát. Próbáld újra.',
  'onboarding.error.name.required': 'Add meg a márka nevét.',
  'onboarding.error.name.tooLong': 'A név legfeljebb {max} karakter lehet.',
  'onboarding.error.name.invalid': 'A név nem tartalmazhat sortörést vagy vezérlőkaraktert.',
  'onboarding.error.logo.required': 'Tölts fel egy logót.',
  'onboarding.error.logo.type': 'A logó JPEG, PNG vagy WebP kép lehet.',
  'onboarding.error.logo.size': 'A logó legfeljebb 10 MB (és 40 megapixel) lehet.',
  'onboarding.error.logo.corrupt': 'A logó fájlja sérült vagy hiányos. Válassz másikat.',
  'onboarding.error.cover.required': 'Tölts fel egy borítóképet.',
  'onboarding.error.cover.type': 'A borítókép JPEG, PNG vagy WebP kép lehet.',
  'onboarding.error.cover.size': 'A borítókép legfeljebb 10 MB (és 40 megapixel) lehet.',
  'onboarding.error.cover.corrupt': 'A borítókép fájlja sérült vagy hiányos. Válassz másikat.',
  'onboarding.error.domain.required': 'Add meg a webshop címét.',
  'onboarding.error.domain.path': 'Csak a cím kell (pl. nova-atelier.hu), útvonal, port és paraméter nélkül.',
  'onboarding.error.domain.invalid': 'Ez nem nyilvános webcím. Példa: nova-atelier.hu',
  'onboarding.error.terms.required': 'A folytatáshoz fogadd el a partneri ÁSZF-et.',
  'onboarding.error.terms.version': 'Az ÁSZF-verziót nem fogadta el a rendszer. Töltsd újra az oldalt.',
  'drops.lead': 'Állíts össze egy dropot: név, leírás, egy vagy több feltöltött termék és az időpont. A drop kezdésétől 24 órán át él az Outfino appban.',
  'drops.emptyHint': 'Az „Új drop” gombbal feltöltesz termékeket, elnevezed a dropot, és beállítod, mikor induljon.',
  'drops.loadFailed': 'Nem sikerült betölteni a dropokat.',
  'drops.delete': 'Törlés',
  'drops.deleteConfirm': 'Biztosan törlöd ezt a dropot? A feliratkozók értesítései is törlődnek.',
  'drops.deleteConfirmActive': 'Ez a drop most él. Ha törlöd, azonnal eltűnik az appból.',
  'drops.deleteYes': 'Törlés',
  'drops.deleting': 'Törlés…',
  'drops.deleted': 'A dropot töröltük.',
  'drops.flow.pick': 'Feltöltött termékek ({n})',
  'drops.flow.start': 'Kezdés',
  'drops.flow.end': 'Vége',
  'drops.flow.endHint': 'A drop a kezdéstől 24 órán át él.',
  'drops.flow.created': 'A drop ütemezve: {date}.',
  'drops.flow.pastDate': 'A kezdés legyen a jövőben.',
  'drops.flow.forbidden': 'Ehhez nincs jogosultságod ennél a márkánál.',
  'drops.upload.title': 'Termék feltöltése',
  'drops.upload.lead': 'Fotók, név, ár és méretek. Az AI rögtön elemzi a terméket (kategória, stílus, címkék).',
  'drops.upload.photos': 'Fotók',
  'drops.upload.main': 'Fő kép',
  'drops.upload.makeMain': 'Legyen ez a fő kép',
  'drops.upload.remove': 'Kép eltávolítása',
  'drops.upload.add': 'Fotók hozzáadása',
  'drops.upload.addMore': 'Még fotó',
  'drops.upload.photosHint': '1–{max} kép, JPEG, PNG vagy WebP, képenként legfeljebb 10 MB. Az első lesz a fő kép.',
  'drops.upload.name': 'Terméknév',
  'drops.upload.price': 'Ár',
  'drops.upload.currency': 'Pénznem',
  'drops.upload.sizes': 'Méretek',
  'drops.upload.sizesHint': 'Vesszővel elválasztva, pl. S, M, L. Elhagyható.',
  'drops.upload.description': 'Leírás (nem kötelező)',
  'drops.upload.submit': 'Feltöltés és elemzés',
  'drops.upload.uploading': 'Feltöltés…',
  'drops.upload.uploadingHint': 'Feltöltjük a képeket, és az AI elemzi a terméket. Ez néhány másodperc.',
  'drops.upload.error.rateLimited': 'Ebben az órában már sok terméket töltöttél fel. Próbáld újra később.',
  'drops.upload.error.rateLimitedFor': 'Ebben az órában már sok terméket töltöttél fel. Próbáld újra {min} perc múlva.',
  'drops.upload.error.forbidden': 'Termék feltöltéséhez nincs jogosultságod ennél a márkánál.',
  'drops.upload.error.failed': 'Nem sikerült feltölteni a terméket. Próbáld újra.',
  'drops.upload.error.images.required': 'Adj hozzá legalább egy fotót.',
  'drops.upload.error.images.tooMany': 'Legfeljebb {max} fotót tölthetsz fel.',
  'drops.upload.error.images.type': 'Csak JPEG, PNG vagy WebP kép tölthető fel.',
  'drops.upload.error.images.size': 'Egy kép legfeljebb 10 MB (és 40 megapixel) lehet.',
  'drops.upload.error.images.corrupt': 'Az egyik kép sérült vagy hiányos. Cseréld le.',
  'drops.upload.error.images.typeAt': 'A(z) {n}. kép nem JPEG, PNG vagy WebP. Cseréld le.',
  'drops.upload.error.images.sizeAt': 'A(z) {n}. kép túl nagy (legfeljebb 10 MB és 40 megapixel).',
  'drops.upload.error.images.corruptAt': 'A(z) {n}. kép sérült vagy hiányos. Cseréld le.',
  'drops.upload.error.images.tooManyAt': 'Legfeljebb {max} fotót tölthetsz fel.',
  'drops.upload.error.images.typeNamed': '„{name}” nem JPEG, PNG vagy WebP kép, ezért kimaradt.',
  'drops.upload.error.images.sizeNamed': '„{name}” nagyobb 10 MB-nál, ezért kimaradt.',
  'drops.upload.error.name.required': 'Add meg a termék nevét.',
  'drops.upload.error.name.tooLong': 'A név legfeljebb 255 karakter lehet.',
  'drops.upload.error.name.invalid': 'Ezt a nevet nem fogadta el a rendszer.',
  'drops.upload.error.price.required': 'Add meg az árat.',
  'drops.upload.error.price.invalid': 'Az ár 0-nál nagyobb szám legyen, legfeljebb 2 tizedesjeggyel (pl. 49990 vagy 49,90).',
  'drops.upload.error.currency.invalid': 'Válassz pénznemet.',
  'drops.upload.error.sizes.tooMany': 'Legfeljebb 30 méret adható meg.',
  'drops.upload.error.sizes.tooLong': 'Egy méret legfeljebb 32 karakter lehet.',
  'drops.upload.error.sizes.invalid': 'A méreteket nem fogadta el a rendszer. Ellenőrizd őket.',
  'drops.upload.error.description.tooLong': 'A leírás legfeljebb 5000 karakter lehet.',
  'drops.upload.error.description.invalid': 'A leírást nem fogadta el a rendszer.',
  'drops.ai.pending': 'AI-elemzés folyamatban',
  'drops.ai.clothing': 'AI-elemzés kész',
  'drops.ai.notClothing': 'Nem ruházati termék',
  'drops.ai.failed': 'Az AI-elemzés nem sikerült',
  'drops.ai.pendingHint': 'Sorban áll; az eredmény magától megjelenik itt.',
  'drops.ai.notClothingHint': 'Az AI szerint ez nem ruha, ezért nem kerülhet dropba. Tölts fel másik terméket.',
  'drops.ai.failedHint': 'Próbáld újra később, vagy tölts fel másik fotót.',
  'drops.ai.category': 'Kategória',
  'drops.ai.style': 'Stílus',
  'drops.ai.tag.type': 'Típus',
  'drops.ai.tag.color': 'Szín',
  'drops.ai.tag.pattern': 'Minta',
  'drops.ai.tag.material': 'Anyag',
  'drops.ai.tag.fit': 'Szabás',
  'drops.ai.tag.length': 'Hossz',
  'drops.edit.open': 'Szerkesztés',
  // ---- Webshop address in Márkaprofil, troubleshooting ----
  'embed.domain.goProfile': 'Ugrás a Márkaprofilhoz',
  'embed.domain.notSet': 'Még nincs megadva',
  'embed.domain.hint': 'A fit-check gomb és a kulcs csak ezen a címen (és a www. változatán) működik. Előbb ezt add meg, utána másolhatod ki a kódokat.',
  'embed.domain.loadFailed': 'Nem sikerült betölteni a webshop címét. Frissítsd az oldalt.',
  // ---- /embedding-problems (public) ----
  'problems.title': 'Beágyazási hibák',
  'problems.eyebrow': 'Outfino fit-check gomb',
  'problems.lead': 'Ha a webshopodban a gomb helyén üzenet jelenik meg, vagy nem látod a gombot, itt megtalálod, mit jelent, és lépésről lépésre, mit kell tenni.',
  'problems.index': 'Hibák',
  'problems.language': 'Nyelv',
  'problems.openPortal': 'Partner portál',
  'problems.permalink': 'Link ehhez a hibához',
  'problems.contact': 'Nem találod a hibát, vagy nem segített? Írj nekünk:',
  'problems.mailSubject': 'Fit-check gomb: beágyazási hiba',
  'problems.where.frame': 'A gomb helyén',
  'problems.where.portal': 'A partner portálon',
  'problems.where.symptom': 'Tünet',
  'problems.link.domain': 'Márkaprofil → A webshop címe',
  'problems.link.settings': 'Beállítások → Beágyazó kód',
  'problems.link.billing': 'Számlázás',
  'problems.link.drops': 'Dropok',
  'problems.link.mail': '{email}',
  'problems.DOMAIN_NOT_SET.short': 'Nincs webshop cím',
  'problems.DOMAIN_NOT_SET.msg': 'A márka még nem adta meg a webshop címét.',
  'problems.DOMAIN_NOT_SET.means': 'A kulcs csak a Márkaprofilban megadott webshop címén működik, és ez még nincs beállítva.',
  'problems.DOMAIN_NOT_SET.step1': 'A partner portálon add meg a webshop címét:',
  'problems.DOMAIN_NOT_SET.step2': 'Csak a címet írd be (pl. nova-atelier.hu), útvonal nélkül, és mentsd.',
  'problems.DOMAIN_NOT_SET.step3': 'Frissítsd a termékoldalt: a gomb pár percen belül megjelenik.',
  'problems.KEY_NOT_ALLOWED.short': 'Másik oldal',
  'problems.KEY_NOT_ALLOWED.msg': 'Ez a kulcs nem ehhez a webshophoz tartozik.',
  'problems.KEY_NOT_ALLOWED.means': 'A kód más oldalon fut, mint a Márkaprofilban megadott webshop címe. A kulcs csak azon a címen (és a www. változatán) működik.',
  'problems.KEY_NOT_ALLOWED.step1': 'Nézd meg, melyik cím van megadva:',
  'problems.KEY_NOT_ALLOWED.step2': 'Ha rossz, írd át a valódi webshop címére, mentsd, és másold ki újra a kódot.',
  'problems.KEY_NOT_ALLOWED.step3': 'Ha jó, a kódot csak azon az oldalon használd (egy másik webshophoz másik márka kell).',
  'problems.BRAND_INACTIVE.short': 'Inaktív márka',
  'problems.BRAND_INACTIVE.msg': 'Ez a márka jelenleg nem aktív az Outfinón.',
  'problems.BRAND_INACTIVE.means': 'A gomb csak aktív márkánál működik: kell egy érvényes kártya és legalább egy aktív termék.',
  'problems.BRAND_INACTIVE.step1': 'Adj meg kártyát:',
  'problems.BRAND_INACTIVE.step2': 'Legyen legalább egy aktív terméked (pl. egy drop, vagy a webshopodból átvett termék):',
  'problems.BRAND_INACTIVE.step3': 'Frissítsd a termékoldalt: pár percen belül újra működik.',
  'problems.BRAND_INACTIVE.causes': 'Ha a kártyád és az aktív terméked is rendben van, az Outfino felfüggeszthette a márkát: ezt a partner portál tetején is jelezzük. A felfüggesztést csak mi tudjuk feloldani, kérdés esetén írj nekünk.',
  'problems.KEY_NOT_FOUND.short': 'Érvénytelen kulcs',
  'problems.KEY_NOT_FOUND.msg': 'Érvénytelen Outfino kulcs.',
  'problems.KEY_NOT_FOUND.means': 'A kódban lévő kulcs nem létezik, vagy már lecserélték.',
  'problems.KEY_NOT_FOUND.causes': 'Gyakori okok: a kódot a teszt (dev) portálról vagy tesztadatokból másolták ki, egy régi kód maradt az oldalon, vagy elírták a kulcsot.',
  'problems.KEY_NOT_FOUND.step1': 'Az éles portálon másold ki újra a kódot:',
  'problems.KEY_NOT_FOUND.step2': 'A webshopodban cseréld le vele a régi kódot.',
  'problems.KEY_NOT_FOUND.step3': 'Mentsd el, és frissítsd a termékoldalt.',
  'problems.MISSING_KEY.short': 'Hiányzó kulcs',
  'problems.MISSING_KEY.msg': 'Az Outfino gomb nincs beállítva: hiányzik a kulcs a beágyazó kódból.',
  'problems.MISSING_KEY.means': 'A beillesztett kódból hiányzik a márkád kulcsa, ezért a gomb nem tudja, kihez tartozik.',
  'problems.MISSING_KEY.step1': 'Másold ki újra a teljes kódot:',
  'problems.MISSING_KEY.step2': 'A webshopodban cseréld le vele a régi kódot (Shopify: a termékoldal „Egyéni Liquid” blokkjában).',
  'problems.MISSING_KEY.step3': 'Mentsd el, és frissítsd a termékoldalt.',
  'problems.POPUP_BLOCKED.short': 'Letiltott ablak',
  'problems.POPUP_BLOCKED.msg': 'A böngésződ nem engedte megnyitni a belépési ablakot.',
  'problems.POPUP_BLOCKED.means': 'A Google- és az Apple-belépés külön ablakban nyílik, és a vásárló böngészője ezt letiltotta.',
  'problems.POPUP_BLOCKED.step1': 'A címsorban kattints a letiltott felugró ablak jelére.',
  'problems.POPUP_BLOCKED.step2': 'Engedélyezd a felugró ablakokat ennél a webshopnál.',
  'problems.POPUP_BLOCKED.step3': 'Kattints újra a belépésre, vagy válaszd a gomb alatti „Belépés új lapon” linket.',
  'problems.NOT_SEEN.short': 'Nincs beállítva',
  'problems.NOT_SEEN.msg': 'Nincs beállítva',
  'problems.NOT_SEEN.means': 'Az elmúlt 7 napban nem láttuk a gombot élő oldalon (nincs megjelenés).',
  'problems.NOT_SEEN.step1': 'Ellenőrizd, hogy a kód egy élő termékoldalon van, nem csak előnézetben vagy piszkozatban.',
  'problems.NOT_SEEN.step2': 'Mentsd el a téma vagy az oldal módosítását; ha az oldal gyorsítótárat (cache, CDN) használ, ürítsd.',
  'problems.NOT_SEEN.step3': 'Nyiss meg egy termékoldalt, és pár percen belül a portálon is látszik:',
  'problems.SHOPIFY_NOT_SHOWN.short': 'Shopify: nem jelenik meg',
  'problems.SHOPIFY_NOT_SHOWN.msg': 'Shopify: a gomb nem jelenik meg a termékoldalon',
  'problems.SHOPIFY_NOT_SHOWN.means': 'A kód nincs a termékoldal sablonjában, vagy a módosított téma nincs közzétéve.',
  'problems.SHOPIFY_NOT_SHOWN.step1': 'Shopify adminban: Online Store → Themes → Customize (Online áruház → Témák → Testreszabás).',
  'problems.SHOPIFY_NOT_SHOWN.step2': 'Felül válaszd a Product (termékoldal) sablont, és nézd meg, ott van-e az „Egyéni Liquid” blokk a kóddal.',
  'problems.SHOPIFY_NOT_SHOWN.step3': 'Ha egy téma másolatát szerkesztetted, tedd közzé (Publish).',
  'problems.UNKNOWN.short': 'Ismeretlen hiba',
  'problems.UNKNOWN.msg': 'Ismeretlen hiba',
  'problems.UNKNOWN.means': 'A gomb olyan hibát jelez, ami nincs a fenti listában, vagy a lépések nem segítettek.',
  'problems.UNKNOWN.step1': 'Frissítsd a termékoldalt, és nézd meg egy másik böngészőben is.',
  'problems.UNKNOWN.step2': 'Készíts egy képernyőképet a hibáról, és másold ki a termékoldal címét.',
  'problems.UNKNOWN.step3': 'Küldd el nekünk, és segítünk:',
  'embed.troubleLink': 'Hibát jelez a gomb? Beágyazási hibák és megoldásuk',
  // ---- Dropok v2 (drop groups) ----
  'drops.notClothing.title': 'Ez nem tűnik ruhadarabnak – tölts fel másik fotót',
  'drops.notClothing.body': 'Az AI szerint a képen nem ruha látszik, ezért ez a termék nem kerülhet dropba.',
  'drops.notClothing.replace': 'Fotó cseréje',
  'drops.notClothing.other': 'Inkább másik terméket töltök fel',
  'drops.product.edit': 'Termék szerkesztése',
  'drops.product.up': 'Feljebb',
  'drops.product.down': 'Lejjebb',
  'drops.product.remove': 'Eltávolítás a dropból',
  'drops.edit.photosHint': 'Az új fotók a meglévők után kerülnek. Ha a fotók, a név vagy a leírás változik, az AI újra elemzi a terméket.',
  'drops.edit.reanalyzeHint': 'Az ár, a pénznem és a méretek módosítása nem indít új AI-elemzést.',
  'drops.edit.saveProduct': 'Termék mentése',
  'drops.upload.error.gone': 'Ez a termék már nem létezik. Tölts fel újat.',
  'drops.group.editTitle': 'Drop szerkesztése',
  'drops.group.startedNote': 'A drop már elindult: a neve, a leírása és a befejezése még módosítható, a termékek és a kezdés nem.',
  'drops.group.details': 'A drop adatai',
  'drops.group.name': 'A drop neve',
  'drops.group.namePlaceholder': 'pl. Téli kapszula',
  'drops.group.description': 'Leírás (nem kötelező)',
  'drops.group.descriptionPlaceholder': 'Pár mondat a dropról, ezt látják a vásárlók az appban.',
  'drops.group.products': 'Termékek',
  'drops.group.noProducts': 'Még nincs termék a dropban. Tölts fel egyet, vagy válassz a korábban feltöltöttek közül.',
  'drops.group.pickTitle': 'Feltöltött termékek',
  'drops.group.nothingToPick': 'Nincs több hozzáadható termék.',
  'drops.group.unnamed': 'Névtelen drop',
  'drops.group.productCount': '{n} termék',
  'drops.group.save': 'Változások mentése',
  'drops.group.saved': 'A dropot mentettük.',
  'drops.group.subscribers': '{n} feliratkozó',
  'drops.group.error.name.required': 'Add meg a drop nevét.',
  'drops.group.error.name.tooLong': 'A név legfeljebb {max} karakter lehet.',
  'drops.group.error.products.required': 'Adj hozzá legalább egy terméket.',
  'drops.group.error.products.tooMany': 'Egy dropban legfeljebb 50 termék lehet.',
  'drops.group.error.products.pending': 'Várd meg, amíg az AI minden terméket elemez.',
  'drops.group.error.products.notClothing': 'Egy termék nem ruhadarab: cseréld a fotóját, vagy vedd ki a dropból.',
  'drops.group.error.start.required': 'Add meg, mikor induljon a drop.',
  'drops.group.error.start.past': 'A kezdés legyen a jövőben.',
  'drops.groupError.product.notClothing': 'Az AI szerint ez nem ruhadarab, ezért nem kerülhet dropba.',
  'drops.groupError.product.pending': 'Az AI még elemzi ezt a terméket. Próbáld újra pár perc múlva.',
  'drops.groupError.product.notDroppable': 'Ez a termék már látható a katalógusban, ezért nem tehető dropba.',
  'drops.groupError.product.inOtherDrop': 'Ez a termék már egy másik ütemezett vagy élő dropban szerepel.',
  'drops.groupError.product.notFound': 'Ez a termék már nem létezik. Vedd ki a dropból.',
  'drops.groupError.INVALID_NAME': 'A drop nevét nem fogadta el a rendszer.',
  'drops.groupError.INVALID_DESCRIPTION': 'A leírás legfeljebb 2000 karakter lehet.',
  'drops.groupError.INVALID_STARTS_AT': 'A kezdés nem érvényes.',
  'drops.groupError.DROP_DATE_IN_PAST': 'A kezdés legyen a jövőben.',
  'drops.groupError.INVALID_PRODUCT_IDS': 'Egy dropban 1–50 termék lehet.',
  'drops.groupError.DROP_ALREADY_STARTED': 'A drop már elindult: a termékek és a kezdés nem módosíthatók.',
  'drops.groupError.DROP_CLOSED': 'Ez a drop már lezárult.',
  'drops.flow.endKept': 'Ennek a dropnak korábban megadott befejezése van.',
  // ---- Billing optional + not-connected nudges (2026-11) ----
  'badge.billing': 'Állítsd be a számlázást',
  'badge.connect': 'Kösd be az Outfinót a webshopodon',
  'billing.setupNote': 'Állítsd be a számlázást, hogy a próbaidő után is folyamatos maradjon a szolgáltatás. Enélkül is használhatod a portál többi részét.',
  'embed.notConnected.stats': 'Még nincs beállítva a gomb a webshopodon. Pár perc, és kész.',
  'embed.notConnected.cta': 'Beüzemelés',
  'onboarding.brandCreated': 'A márkád elkészült',

  // ---- Beüzemelés (guided onboarding) ----
  'tab.onboarding': 'Beüzemelés',
  'group.onboarding': 'Beüzemelés',
  'badge.onboarding': 'Fejezd be a beüzemelést',
  'onboarding.hero.title': 'Beüzemelés',
  'onboarding.hero.lead': 'Néhány lépés, és él az Outfino próbagombja a webshopodon. Haladj sorban — minden lépés kinyitható.',
  'onboarding.progress': '{n}/{total} kész',
  'onboarding.optional': 'opcionális',
  'onboarding.done.title': 'Kész! Élsz az Outfinón.',
  'onboarding.done.body': 'A gomb él a boltodban, és a termékeid betöltődtek. A statisztikák hamarosan megjelennek.',

  'onboarding.billing.title': 'Állítsd be a számlázást',
  'onboarding.billing.why': 'Hogy a próbaidő után is folyamatos maradjon — enélkül is minden működik.',
  'onboarding.billing.body': 'A számlázás nem kötelező, de érdemes megadnod egy kártyát, hogy a próbaidő lejárta után se álljon le a szolgáltatás.',
  'onboarding.billing.cta': 'Tovább a Számlázáshoz',

  'onboarding.button.title': 'Tedd ki a gombot a webshopodon',
  'onboarding.button.why': 'Ez az Outfino „Nézd meg, hogy passzol-e” gombja a termékoldalon.',
  'onboarding.button.body': 'Add meg a webshopod címét, majd másold be a kódot a termékoldalra. A design és a kód lentebb, platformonként.',

  'onboarding.products.title': 'Töltsd fel vagy fetcheld a termékeidet',
  'onboarding.products.why': 'Hogy a gomb a te termékeidre tudjon illeszkedni.',
  'onboarding.products.body': 'Behúzzuk a termékeket a webshopod címéről (csak a sajátodról), és előkészítjük őket az illesztéshez. Shopify és sitemap alapú boltot is ismerünk.',
  'onboarding.products.have': 'Jelenleg {n} termék van betöltve.',
  'onboarding.products.crawl': 'Termékek fetchelése',
  'onboarding.products.crawling': 'Fetchelés folyamatban…',
  'onboarding.products.view': 'Termékek megtekintése',
  'onboarding.products.needDomain': 'Előbb add meg a webshopod címét a 2. lépésben.',
  'onboarding.products.unavailable': 'A termék-fetchelés hamarosan elérhető. Addig töltsd fel a termékeket a Termékek oldalon.',
  'onboarding.products.progress': 'Találat: {found} · Betöltve: {ingested}',
  'onboarding.products.phase.queued': 'Előkészítés…',
  'onboarding.products.phase.discovering': 'Termékek keresése…',
  'onboarding.products.phase.ingesting': 'Termékek betöltése…',
  'onboarding.products.phase.done': 'Kész',
  'onboarding.products.crawlDone': 'Kész! {n} termék betöltve.',
  'onboarding.products.error.NO_PRODUCTS': 'Nem találtunk termékeket ezen a címen. Ellenőrizd a webshop címét, vagy töltsd fel kézzel.',
  'onboarding.products.error.DOMAIN_NOT_SET': 'A webcím nincs beállítva. Add meg a 2. lépésben.',
  'onboarding.products.error.CRAWL_FAILED': 'Nem sikerült a fetchelés. Próbáld újra kicsit később.',

  'onboarding.test.title': 'Teszteld',
  'onboarding.test.why': 'Ellenőrizzük élőben, hogy a gomb működik-e a boltodban.',
  'onboarding.test.body': 'A Teszt gomb lefuttatja az ellenőrzéseket, és megmutatja, mi van kész és mi hiányzik.',
  'onboarding.test.run': 'Teszt',
  'onboarding.test.running': 'Tesztelés…',
  'onboarding.test.pass': 'Kész! Az Outfino gomb él a boltodban.',
  'onboarding.test.fail': 'A gomb még nem él. Nézd meg a lenti ellenőrzéseket.',
  'onboarding.test.degraded': 'Egyszerűsített ellenőrzés (a részletes teszt hamarosan elérhető).',
  'onboarding.test.error.KEY_NOT_FOUND': 'Nincs érvényes kulcs. Másold be újra a kódot a 2. lépésből.',
  'onboarding.test.error.DOMAIN_NOT_SET': 'A webshop címe nincs beállítva. Add meg a 2. lépésben.',
  'onboarding.test.error.BRAND_INACTIVE': 'A márka még nem futtathatja a gombot. Vedd fel velünk a kapcsolatot.',
  'onboarding.test.error.KEY_NOT_ALLOWED': 'A gomb más címen fut, mint amit beállítottál. Ellenőrizd a webshop címét.',
  'onboarding.test.error.NO_IMPRESSIONS': 'Még nem érkezett megjelenítés. Nyisd meg a gombot a boltod egyik termékoldalán.',
  'onboarding.check.keyValid': 'Érvényes kulcs',
  'onboarding.check.domainSet': 'Webshop címe megadva',
  'onboarding.check.brandActive': 'A márka futtathatja a gombot',
  'onboarding.check.impressionSeen': 'A gomb megjelent a boltban',
  'onboarding.check.eventsSeen': 'Látogatói interakció érkezett',
  'onboarding.check.pixelSeen': 'Vásárlás-követés (pixel) aktív',
  'onboarding.check.fix': 'Megoldás',
  'onboarding.check.learn': 'Tudj meg többet',
  'onboarding.check.lastSeen': 'utoljára {ago}',
  'onboarding.check.hint.keyValid': 'A kulcs nem található vagy érvénytelen.',
  'onboarding.check.hint.domainSet': 'A webshop címe nincs beállítva.',
  'onboarding.check.hint.brandActive': 'A márka még nem futtathatja a gombot.',
  'onboarding.check.hint.impressionSeen': 'Még nem láttunk megjelenést a boltodban — tedd ki a gombot és nyiss meg egy terméket.',
  'onboarding.check.hint.eventsSeen': 'Még nem érkezett látogatói interakció a gombból.',
  'onboarding.check.hint.pixelSeen': 'Még nem láttuk a pixelt működni.',
  // Teszt-gated status + a gomb al-lépései (accordion)
  'onboarding.untested': 'Még nem futtattál tesztet. Nyomd meg a „Teszt" gombot, hogy lássuk, mi működik.',
  'onboarding.test.loadError': 'Nem sikerült lefuttatni a tesztet. Próbáld újra.',
  'onboarding.sub.key.title': 'Embed-kulcs',
  'onboarding.sub.key.body': 'Ez a márkád publikus kulcsa (ofk_live_…). A kód már tartalmazza; másold ki, ha külön kell.',
  'onboarding.sub.code.title': 'A gomb kódja a termékoldalra',
  'onboarding.sub.code.body': 'Másold be a kódot a termékoldaladra, ahol a gombot szeretnéd — platformonként (Shopify / egyéb webshop).',
  'onboarding.sub.domain.title': 'A webshop címe',
  'onboarding.sub.domain.body': 'Add meg a webshopod címét — a gomb csak ezen a címen (és a www. változatán) működik, ahol fut.',
  'onboarding.sub.pixel.title': 'Pixel (vásárlás-követés)',
  'onboarding.sub.pixel.body': 'Ha szeretnéd mérni a kosárba tételt és a vásárlást, tedd ki a pixelt is — opcionális.',
  'onboarding.sub.hint.key': 'A kulcs nem található vagy érvénytelen. Másold be újra a kódot.',
  'onboarding.sub.hint.code': 'Még nem láttunk megjelenést a boltodban — tedd ki a gombot, és nyiss meg egy termékoldalt.',
  'onboarding.sub.hint.domain': 'A webcím nincs beállítva. Add meg a webshopod címét.',
  'onboarding.sub.hint.domainMismatch': 'A gomb más címen fut, mint amit beállítottál. Ellenőrizd a webshop címét.',
  'onboarding.sub.hint.pixel': 'Még nem láttuk a pixelt működni. Tedd ki a pixel-kódot a vásárlás-követéshez.',
};

export default hu;
